// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:03.557Z
// Property: Pointe at River City (ID: 6767906449166340)
// Collections: 23 amenities, 4 floorplans (live), 19 photos, 79 POIs, 3 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166340",
  "property_external_id": "30914",
  "property_zillow_url": "https://www.zillow.com/apartments/richmond-va/pointe-at-river-city/5XnsDJ/",
  "property_apartments_url": "https://www.apartments.com/pointe-at-river-city-richmond-va/kzlg488/",
  "property_google_business_url": "https://www.google.com/maps/place/Pointe+at+River+City+Apartment+Homes/data=!4m2!3m1!1s0x0:0x9f158e32b52045dc?sa=X&ved=2ahUKEwjI-euo27iSAxUiG9AFHZDEKdkQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "pointe-at-river-city",
  "property_name": "Pointe at River City",
  "property_website_url": "https://www.pointeatrivercity.com/",
  "property_domain": "https://www.pointeatrivercity.com/",
  "property_address": "11 North Laburnum Avenue",
  "property_full_address": "11 N Laburnum Ave, Richmond, VA 23223",
  "property_address_1": "11 N Laburnum Ave",
  "property_address_2": null,
  "property_address_city": "Richmond",
  "property_address_state": "VA",
  "property_address_zip_full": "23223-5701",
  "property_address_zip": "23223",
  "property_address_country": "US",
  "property_address_county": "Henrico County",
  "property_neighborhood_address": "Eastern Henrico County",
  "property_address_latitude": "37.5456585",
  "property_address_longitude": "-77.3704293",
  "property_email": "pointerivercity@aionmanagement.com",
  "property_phone": "(804) 424-4883",
  "property_call_tracking_phone": "888-970-6545",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Pointe at River City, where modern comfort meets serene views in Richmond, VA. Our pet-friendly community offers spacious two-bedroom layouts, complete with upgraded kitchens, a refreshing swimming pool, and inviting outdoor spaces. Experience convenience with flex rent payments and 24-hour maintenance. Your ideal home awaits!",
  "property_long_description": "**Discover Your Dream Home at Pointe at River City**\n\nWelcome to Pointe at River City, a vibrant apartment community nestled in Richmond, VA, where modern living meets exceptional comfort. Our thoughtfully designed two-bedroom floor plans offer a perfect blend of style and functionality, ensuring you feel right at home. Enjoy breathtaking views from your private balcony or patio, and revel in the luxurious touches of our renovated kitchens featuring granite countertops and stainless steel appliances.\n\nAt Pointe at River City, we prioritize your convenience and community experience. Our residents enjoy access to fantastic amenities including a resort-style swimming pool, a well-equipped fitness center, and an inviting courtyard complete with grilling stations and picnic areas. Your furry friends are welcome too, with our pet-friendly policy and dedicated dog park! \n\nStay connected with high-speed internet availability and take advantage of our online resident portal for hassle-free rent payments. Our community also offers resident activities to foster neighborly connections, making it easy to feel at home. \n\nWith 24-hour emergency maintenance, on-site management, and convenient guest parking, we ensure that all your needs are met promptly and professionally. Choose from short-term lease options or settle into one of our spacious townhomes designed with modern comforts, including vaulted ceilings, cozy fireplaces, and wood plank or wall-to-wall carpeting.\n\nExperience upscale living in an unbeatable location. **Find your new home today—browse our availability or schedule a tour to visit our community!** Enjoy the lifestyle you deserve at Pointe at River City!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-0b28-717a-8ef3-8b1abfcc7ce2.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a brick apartment building with white columns and a red front door.",
    "public_id": "019fce07-0b28-717a-8ef3-8b1abfcc7ce2",
    "storage_key": "property/6767906449166340/019fce07-0b28-717a-8ef3-8b1abfcc7ce2.webp",
    "width": 1920,
    "height": 1080
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "1184",
  "property_year_built": "1965",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.62162162162163",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time non‑refundable pet fee: $350 per pet. Monthly pet rent: $70 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://pointeatrivercity.loftliving.com/login",
  "property_apply_now_url": "https://www.pointeatrivercity.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d0269-e9e0-7640-b44c-58f0198ecef8.webp",
  "property_primary_logo_media": {
    "alt_text": "Pointe at River City logo",
    "public_id": "019d0269-e9e0-7640-b44c-58f0198ecef8",
    "storage_key": "property/6767906449166340/019d0269-e9e0-7640-b44c-58f0198ecef8.webp",
    "width": 792,
    "height": 521
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026c-7db7-72bc-ad7b-6fb0c331d311.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION Management logo",
    "public_id": "019d026c-7db7-72bc-ad7b-6fb0c331d311",
    "storage_key": "property/6767906449166340/019d026c-7db7-72bc-ad7b-6fb0c331d311.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026c-89bd-70ff-b752-ef3283c57a89.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Pointe at River City logo",
    "public_id": "019d026c-89bd-70ff-b752-ef3283c57a89",
    "storage_key": "property/6767906449166340/019d026c-89bd-70ff-b752-ef3283c57a89.webp",
    "width": 640,
    "height": 421
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026c-93ea-77f5-a2c1-ebedbd0e73a0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Pointe at River City logo",
    "public_id": "019d026c-93ea-77f5-a2c1-ebedbd0e73a0",
    "storage_key": "property/6767906449166340/019d026c-93ea-77f5-a2c1-ebedbd0e73a0.webp",
    "width": 640,
    "height": 421
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "784 - 784",
  "property_sqft_min": "784",
  "property_sqft_max": "784",
  "property_price_range": "2218",
  "property_price_min": null,
  "property_price_max": "2218",
  "property_available_units": 40,
  "property_facebook_url": "https://www.facebook.com/PointeatRiverCity",
  "property_instagram_url": "https://www.instagram.com/pointeatrivercity/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJr10uZgQasYkR3EUgtTKOFZ8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Sandston%2C+VA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pointe at River City",
  "property_home_romance_title": "Embrace Your Ideal Living Space, Create Lasting Memories Here",
  "property_home_amenities_blurb": "At Pointe at River City in Richmond, VA, you're invited to experience modern living with charming amenities. Enjoy a sun-soaked sundeck, playful dog park, and inviting grilling stations—all designed for community fun. Our upgraded apartments feature stylish kitchens, serene pond views, and cozy fireplaces, creating the perfect retreat for you.",
  "property_home_floorplans_blurb": "At Pointe at River City in Richmond, VA, our spacious two-bedroom apartments offer the perfect blend of comfort and style. Embrace modern living in a vibrant community. Browse our available apartment homes today and uncover the floor plan that complements your lifestyle. Your ideal home awaits!",
  "property_home_gallery_blurb": "Welcome to Pointe at River City, where modern living meets serene river views. With spacious two-bedroom floor plans, high-speed internet, and a pet-friendly atmosphere, you’ll thrive here. Enjoy resident activities, grilling stations, and a stunning swimming pool—your idyllic home awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Pointe at River City, your vibrant lifestyle mingles with rich culture and convenience. Nestled in Richmond, VA, our community is a stone's throw from the Science Museum of Virginia, Virginia Museum of Fine Arts, and picturesque parks. Embrace vital connections to education and recreation while enjoying a spacious two-bedroom sanctuary.",
  "property_home_reviews_blurb": "Welcome to Pointe at River City in Richmond, VA, where our residents thrive in a clean, welcoming environment! Enjoy the convenience of excellent maintenance and responsive management, as one delighted tenant remarked, “Great office staff! What more can you ask for?” Join our vibrant community and experience a perfect blend of comfort and accessibility!",
  "property_neighborhood_blurb": "At Pointe at River City in Richmond, VA, your lifestyle thrives amidst a vibrant tapestry of culture and convenience. Just steps away, you'll find the wonders of the Virginia Museum of Fine Arts, the lush serenity of Lewis Ginter Botanical Garden, and the engaging exhibitions at the Science Museum of Virginia. Embrace a community where everyday adventures await!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pointe at River City in Richmond, VA, enjoy modern living amidst vibrant amenities. Relax by the swimming pool, host a barbecue at our grilling stations, or let your furry friend roam in the dog park. With spacious two-bedroom layouts and stylish finishes, your perfect home awaits!",
  "property_applynow_blurb": "Experience a lifestyle of comfort and convenience at Pointe at River City in Richmond, VA. Choose from our spacious two-bedroom floor plans featuring modern finishes and a range of amenities, including a sparkling pool, dog park, and vibrant community activities. Apply now and secure your new home today!",
  "property_contactus_blurb": "At Pointe at River City in Richmond, VA, our spacious two-bedroom floor plans offer the perfect blend of comfort and modern living. With stunning views and thoughtfully designed layouts, your new home awaits. Have questions? Contact our leasing team today to learn more about life at Pointe at River City!",
  "property_faqs_blurb": "At Pointe at River City in Richmond, VA, our two-bedroom apartments blend comfort with style. Curious about life in our vibrant community? Our FAQs page is your go-to resource for answers, ensuring you feel right at home before you even step through the door. Check it out today!",
  "property_floorplans_blurb": "At Pointe at River City in Richmond, VA, our spacious two-bedroom floor plans blend comfort with modern living. Each layout is thoughtfully designed to elevate your lifestyle. Ready to make a move? Browse our available apartment homes and uncover the perfect space tailored just for you.",
  "property_gallery_blurb": "At Pointe at River City in Richmond, VA, every corner tells a story. Revel in two-bedroom plans enhanced with upgraded kitchens and vaulted ceilings. Enjoy a pet-friendly community featuring a swimming pool, grilling stations, and serene pond views. Picture yourself living here, where comfort meets modern elegance!",
  "property_interactivemap_blurb": "At Pointe at River City in Richmond, VA, your perfect two-bedroom apartment awaits! Enjoy upgraded kitchens, stunning views, and a vibrant community with amenities like a pet-friendly dog park, refreshing swimming pool, and cozy fireplaces. Use our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Pointe at River City in Richmond, VA, you'll find a vibrant community that caters to both you and your furry companions. With spacious apartments and a welcoming pet policy for cats and dogs up to 100 lbs, living here means embracing comfort, convenience, and the joy of pet companionship.",
  "property_referafriend_blurb": "At Pointe at River City in vibrant Richmond, VA, our spacious two-bedroom floor plans offer the perfect backdrop for memorable moments with friends. Great friends make great neighbors—refer a friend today and share the comfort of our welcoming community. Experience the lifestyle you both deserve!",
  "property_residentaccess_blurb": "At Pointe at River City in Richmond, VA, our spacious two-bedroom floor plans offer the perfect blend of comfort and style. Enjoy the convenience of our resident portal to effortlessly pay rent, schedule maintenance, and stay connected to your community. Access your portal today for a seamless living experience!",
  "property_reviews_blurb": "At Pointe at River City in Richmond, VA, residents rave about the \"clean, cute floor layout\" and the dedication of our team who \"stay on top of repairs and renovations.\" With low rents, pet-friendly policies, and exciting dining options nearby, your new home awaits! See what our residents have to say about living at our community!",
  "property_created_at": "1757011309282",
  "property_scheduletour_blurb": "At Pointe at River City in Richmond, VA, our two-bedroom floor plans blend comfort with contemporary style. Each apartment invites you to experience spacious living and scenic views. Curious about life here? Schedule a tour and see why our residents love calling Pointe at River City home!",
  "property_thankyou_blurb": "Thank you for reaching out to Pointe at River City in beautiful Richmond, VA! We’re excited to connect with you soon. With spacious two-bedroom floor plans and breathtaking views, your ideal home awaits. Stay tuned for updates as we help you take the next step toward comfortable living!",
  "property_virtualtours_blurb": "At Pointe at River City in Richmond, VA, our spacious two-bedroom apartments offer the perfect blend of comfort and style. With stunning layouts and modern amenities, you’ll feel right at home. Immerse yourself in our vibrant community—take a virtual tour today and envision your future here!",
  "property_copyright": "2025 All Rights Reserved. Pointe at River City",
  "property_seo_title_home": "Pointe at River City |  Apartments in Richmond, VA",
  "property_seo_description_home": "Discover modern living at Pointe at River City! Enjoy spacious layouts, great amenities, and stunning views in vibrant Richmond, VA!",
  "property_seo_title_floorplans": "Floor Plans | Richmond, VA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal 2-bedroom oasis at Pointe at River City in Richmond, VA. Uncover spacious layouts designed for comfort—your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Richmond, VA Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Pointe at River City, Richmond's top pet-friendly community with updated apartments, a pool, and fun resident activities!",
  "property_seo_title_gallery": "Gallery | Apartments in Richmond, VA",
  "property_seo_description_gallery": "Imagine life at Pointe at River City! Enjoy stunning views, vibrant amenities, and modern apartments in Richmond, VA. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Pointe at River City Apartments",
  "property_seo_description_virtualtours": "Experience Pointe at River City in Richmond, VA! Dive into our two-bedroom floor plans and take a virtual tour of your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | Pointe at River City Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Pointe at River City! Explore available apartments with our interactive map, blending modern amenities and community living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Richmond, VA",
  "property_seo_description_neighborhood": "Uncover the vibrant local scene around Pointe at River City, Richmond, VA. From parks to restaurants, find your next favorite spot just steps from home!",
  "property_seo_title_contact": "Contact Us | Pointe at River City",
  "property_seo_description_contact": "Connect with Pointe at River City in Richmond, VA! Explore our spacious two-bedroom floor plans. Have questions? Our leasing team is ready to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Richmond, VA",
  "property_seo_description_faqs": "Uncover important insights about Pointe at River City in Richmond, VA. Browse our FAQs for details on amenities, floor plans, and community living!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Richmond, VA",
  "property_seo_description_reviews": "Experience life at Pointe at River City in Richmond, VA! From modern amenities to vibrant resident activities, see why our community is home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Richmond, VA",
  "property_seo_description_applynow": "Discover modern living at Pointe at River City! Enjoy pet-friendly amenities, renovated interiors, and a vibrant community in Richmond.",
  "property_seo_title_residentaccess": "Resident Access | Pointe at River City",
  "property_seo_description_residentaccess": "Log in to your resident portal at Pointe at River City in Richmond, VA. Pay rent, request maintenance, and manage your living experience with ease!",
  "property_seo_title_referafriend": "Refer A Friend | Pointe at River City",
  "property_seo_description_referafriend": "Help a friend find their perfect home at Pointe at River City! Refer them today and enjoy the benefits of great neighbors in beautiful Richmond, VA.",
  "property_seo_title_scheduletour": "Schedule a Tour | Pointe at River City",
  "property_seo_description_scheduletour": "Experience a vibrant lifestyle at Pointe at River City, Richmond, VA. Schedule your tour today and step into your future home filled with amenities and charm!",
  "property_seo_title_privacy": "Privacy Policy | Pointe at River City",
  "property_seo_description_privacy": "Your privacy matters at Pointe at River City. Learn how we protect your information and ensure a secure living experience in Richmond, VA. View our policy now.",
  "property_seo_title_accessibility": "Website Accessibility | Pointe at River City",
  "property_seo_description_accessibility": "At Pointe at River City in Richmond, VA, we prioritize accessibility for all. Experience digital inclusivity and comfort in our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Pointe at River City",
  "property_seo_description_sitemap": "Uncover the layout of Pointe at River City in Richmond, VA. Navigate our community amenities, floor plans, and more with ease. View our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Pointe at River City",
  "property_seo_description_thankyou": "Thank you for your interest in Pointe at River City! Expect a warm welcome from our team soon. Your ideal Richmond home awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Richmond, VA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792699344466",
  "amenities": [
    {
      "id": "custom_2b5d3b35-a6a7-426b-9c67-d96a759d8957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7660cb7-f1e6-4fc0-b5a9-d0c54e1b8ea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfd7d4c5-f08e-413f-8a0e-a534ae5f8df9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf413c72-347e-470d-8e03-a26ff3770f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4000e6d-c80c-42c4-a9a6-62895594a07f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_208483b0-3e2d-4aed-b899-43ddb49f330a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d24b38ae-c174-4cc5-b00d-41bc17144320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0602bcc-a259-4c8c-8269-c73bdf862141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f111dc6d-f0f7-4099-add8-064abc047c85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7880d6f4-576b-4b97-a686-ad01f962f64f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Range*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc865502-1dfb-4911-ac4a-ca319ab515de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b847ded0-e832-4c46-b7b1-b1bc2302ff53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa863bd5-cfc1-4e07-a00b-71fa221ebe19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efa34ccb-3dbc-4a20-87bf-25864239d203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3a412cc-2f6d-4446-bd69-8e5bad32fdbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b870483-ca7a-49a3-b419-e30de1bff020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_908de293-4364-4b1c-9417-175b45c9df77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Located in the Henrico County Public School District",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aadf3b83-a26f-492f-a138-143a111c62d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Near Downtown Richmond & Virginia Commonwealth University",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4b3fe25-696e-4b47-9a6d-5265b3d64a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "2 Dog Parks",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2461b9da-c341-45f2-9368-a70e37b18698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "2 Swimming Pools with Sundecks",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d25417ac-dec9-480b-8448-c2c8312759f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "3 Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1dcd238a-5d9c-4d61-8cf8-9faae412ee4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident and Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_68a3cc5d-8670-44af-9b47-335a74a1166e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_cadb6e6a-3a7b-4d94-a0b9-808f215cf4dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-1b51-765b-ab28-23f4d150bc21.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances, including a refrigerator and stove. A large window overlooks the neighborhood.",
        "public_id": "019fce07-1b51-765b-ab28-23f4d150bc21",
        "storage_key": "property/6767906449166340/019fce07-1b51-765b-ab28-23f4d150bc21.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Experience effortless cooking in this modern kitchen, featuring ample white cabinetry, elegant granite countertops, and a full suite of sleek black appliances. A spacious window provides natural light and a view of the surrounding homes.",
      "link": "false",
      "alt_text": "Bright, modern kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/4babe9995d9a221bd37d249b90680c76.jpg"
    },
    {
      "id": "custom_e7125659-1fad-471b-a7c0-9f31b4b456d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-1aff-71f0-a2d3-f8b8b6ec8cae.webp",
      "image_media": {
        "alt_text": "A bedroom with a desk, bed, and artwork.",
        "public_id": "019fce07-1aff-71f0-a2d3-f8b8b6ec8cae",
        "storage_key": "property/6767906449166340/019fce07-1aff-71f0-a2d3-f8b8b6ec8cae.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "This bedroom features a comfortable bed, a functional desk area, and decorative artwork, creating a cozy and stylish living space.",
      "link": "false",
      "alt_text": "Bedroom with desk and daybed, window with blinds, and two cityscape paintings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/3ee12c30a47dbd934494586d4fa8801a.jpg"
    },
    {
      "id": "custom_976f5ddc-fa36-4bb4-9c1f-4787e939f789",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-1b36-771e-a387-ac9b5ea2eb6c.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and dresser.",
        "public_id": "019fce07-1b36-771e-a387-ac9b5ea2eb6c",
        "storage_key": "property/6767906449166340/019fce07-1b36-771e-a387-ac9b5ea2eb6c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment living room with neutral gray walls, light sofa, coffee table, and natural light from two windows.",
      "link": "false",
      "alt_text": "Living room with gray walls, a light sofa, coffee table, TV on a wooden console, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/4911b29ccd6234f791fca4c29a0395cb.jpg"
    },
    {
      "id": "custom_3bc7b538-1606-49ca-8db0-4f2391b3abdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-1b29-7649-938b-e92d791f6c12.webp",
      "image_media": {
        "alt_text": "Updated kitchen with white cabinets, granite countertops, and a stacked washer/dryer.",
        "public_id": "019fce07-1b29-7649-938b-e92d791f6c12",
        "storage_key": "property/6767906449166340/019fce07-1b29-7649-938b-e92d791f6c12.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white cabinets, black appliances, granite counters, and a stacked laundry unit.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black fridge and stove, and a stacked washer/dryer on the left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/0ae2db6b66907123da7086cbb643614b.jpg"
    },
    {
      "id": "custom_4a376e2e-76e8-492d-8593-27b2b0ef076d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-2611-7159-b8ae-372852248fa8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fce07-2611-7159-b8ae-372852248fa8",
        "storage_key": "property/6767906449166340/019fce07-2611-7159-b8ae-372852248fa8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Well-appointed apartment kitchen with white cabinets, granite counters, stainless steel appliances, and natural light from the window.",
      "link": "false",
      "alt_text": "Bright kitchen with white cabinets, granite countertops, stainless-steel stove and range hood, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/f3c952d4ac3a5f9f0011c84f4c313796.jpg"
    },
    {
      "id": "custom_9990c7e9-b15c-4bae-9254-415d88de112f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-2658-7678-936c-1d49ad88d6ba.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with neutral decor.",
        "public_id": "019fce07-2658-7678-936c-1d49ad88d6ba",
        "storage_key": "property/6767906449166340/019fce07-2658-7678-936c-1d49ad88d6ba.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living room with open kitchen, neutral finishes, and contemporary furniture.",
      "link": "false",
      "alt_text": "Open-concept living area with beige carpet, coffee table, TV, and white kitchen cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/63e46f99817f3f16b0de647076ac752f.jpg"
    },
    {
      "id": "custom_5d18e88f-3ce4-465c-b996-455844695ecd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-264a-769e-93b7-9159f6977859.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019fce07-264a-769e-93b7-9159f6977859",
        "storage_key": "property/6767906449166340/019fce07-264a-769e-93b7-9159f6977859.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush sofa, a decorative coffee table with flowers, and a television on a media console. Large windows offer a view of the community.",
      "link": "false",
      "alt_text": "Living room with beige tufted sofa, round coffee table, TV on a wooden console, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/1bb9449ae73cbf83daf6cba81aeee010.jpg"
    },
    {
      "id": "custom_bb837774-3636-49e7-a348-96b6c6017211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-2648-704e-acff-9a2f537dfd02.webp",
      "image_media": {
        "alt_text": "Stacked white washer and dryer in a closet with a white door.",
        "public_id": "019fce07-2648-704e-acff-9a2f537dfd02",
        "storage_key": "property/6767906449166340/019fce07-2648-704e-acff-9a2f537dfd02.webp",
        "width": 891,
        "height": 1335
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with a white stacked washer and dryer behind a partially open door.",
      "link": "false",
      "alt_text": "White stacked washer and dryer in a closet behind a partially open door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/ec88e78a0ca96eee047648c9debc3aee.jpg"
    },
    {
      "id": "custom_6657bce3-3b3d-46a3-a668-1ec2ade72e70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-2f8d-7215-afa8-1f9287d40e51.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with a vanity, toilet, and shower/tub.",
        "public_id": "019fce07-2f8d-7215-afa8-1f9287d40e51",
        "storage_key": "property/6767906449166340/019fce07-2f8d-7215-afa8-1f9287d40e51.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom with a white vanity, storage, and tub/shower.",
      "link": "false",
      "alt_text": "White apartment bathroom with vanity, mirrored cabinet, toilet, and a tub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/f879703961b88902b24cbf5ed7abb927.jpg"
    },
    {
      "id": "custom_84a80469-e571-47b2-9bc3-744ce94b1cc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-316e-71a0-88cd-e7121c55ab32.webp",
      "image_media": {
        "alt_text": "Sun-drenched swimming pool with lounge chairs and a wooden pergola.",
        "public_id": "019fce07-316e-71a0-88cd-e7121c55ab32",
        "storage_key": "property/6767906449166340/019fce07-316e-71a0-88cd-e7121c55ab32.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Sun-soaked outdoor pool at our apartment community with lounge chairs, shaded seating, and a fenced recreation area.",
      "link": "false",
      "alt_text": "Outdoor community pool under a wooden pergola with rows of lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/7bdc192015e54b6bb27507bde179997d.jpg"
    },
    {
      "id": "custom_42fd42ff-5a43-45b2-9703-18f4eb7d390f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-31c4-74da-aec0-2646401de6ee.webp",
      "image_media": {
        "alt_text": "An outdoor swimming pool surrounded by lounge chairs and umbrellas.",
        "public_id": "019fce07-31c4-74da-aec0-2646401de6ee",
        "storage_key": "property/6767906449166340/019fce07-31c4-74da-aec0-2646401de6ee.webp",
        "width": 1469,
        "height": 981
      },
      "title": "Community",
      "description": "Sunny outdoor pool area at a multifamily community, with lounge chairs and fencing.",
      "link": "false",
      "alt_text": "Outdoor community swimming pool with lounge chairs and red umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/f084086de0a71900b205cdbaa2872ca5.jpg"
    },
    {
      "id": "custom_2787ed48-64c3-4858-8191-fcd89f9efcbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-363e-76b9-b019-813b91b41a79.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, picnic tables, and built-in grills on a sunny day.",
        "public_id": "019fce07-363e-76b9-b019-813b91b41a79",
        "storage_key": "property/6767906449166340/019fce07-363e-76b9-b019-813b91b41a79.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Sun-filled outdoor pool at the apartment community with lounge seating, umbrellas, and a shaded pergola.",
      "link": "false",
      "alt_text": "Outdoor apartment community pool with lounge chairs, tables, umbrellas, and a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/0aa481599a390517e876e489aa7bf7e8.jpg"
    },
    {
      "id": "custom_58bdac77-d088-4702-90eb-60512c1ac18c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-3c8b-721e-8f16-7eabd9cff16d.webp",
      "image_media": {
        "alt_text": "Playground area with colorful slides and swings, fenced yard, and apartment buildings in the background.",
        "public_id": "019fce07-3c8b-721e-8f16-7eabd9cff16d",
        "storage_key": "property/6767906449166340/019fce07-3c8b-721e-8f16-7eabd9cff16d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring vibrant slides and swings. Located in a scenic area with ample green space for relaxation and recreation.",
      "link": "false",
      "alt_text": "Fenced grassy playground with a colorful play structure, brick apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/9eeecb033ddc690015728d3b37f81f2c.jpg"
    },
    {
      "id": "custom_3c8c3372-6de8-4830-99d7-db9fbadace0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-3c20-7524-888b-ae9ce3dd9c68.webp",
      "image_media": {
        "alt_text": "Orange sign with black paw print and \"DOG PARK\" text.",
        "public_id": "019fce07-3c20-7524-888b-ae9ce3dd9c68",
        "storage_key": "property/6767906449166340/019fce07-3c20-7524-888b-ae9ce3dd9c68.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Signage for the property's dog park, featuring a bold orange circle, a black paw print, and DOG PARK text.",
      "link": "false",
      "alt_text": "Orange circular sign with a black paw print and DOG PARK lettering.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/9301ababd0745b3b78c75ffa2cf8e301.jpg"
    },
    {
      "id": "custom_62a1b67d-1e7f-4ceb-8fdf-453e912ef34c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-4123-74ff-aadc-81421f4ece7f.webp",
      "image_media": {
        "alt_text": "Playground with slides and a swimming pool with lounge chairs in the background.",
        "public_id": "019fce07-4123-74ff-aadc-81421f4ece7f",
        "storage_key": "property/6767906449166340/019fce07-4123-74ff-aadc-81421f4ece7f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Outdoor amenities at the apartment community, featuring a colorful playground and a pool for residents.",
      "link": "false",
      "alt_text": "Playground with red and green equipment near a pool at an apartment community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/c4aa12d9190ee2478ff81f2b13a2d655.jpg"
    },
    {
      "id": "custom_6b5c6c1f-f814-489b-add8-d967ed513cf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-427e-73b4-84be-bce28de5d9c6.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings",
        "public_id": "019fce07-427e-73b4-84be-bce28de5d9c6",
        "storage_key": "property/6767906449166340/019fce07-427e-73b4-84be-bce28de5d9c6.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Outdoor community playground at a multifamily property featuring bright blue, red, and yellow play structures.",
      "link": "false",
      "alt_text": "Colorful playground with slides and climbing structures in a fenced area beside a brick apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/eb8ce0d8ea6033cfdc7220240869fba7.jpg"
    },
    {
      "id": "custom_816b3576-267d-4946-af5c-3c037397767f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-4931-73be-aa37-c8518bf1163e.webp",
      "image_media": {
        "alt_text": "Playground with red and blue structures and green slide under a blue sky.",
        "public_id": "019fce07-4931-73be-aa37-c8518bf1163e",
        "storage_key": "property/6767906449166340/019fce07-4931-73be-aa37-c8518bf1163e.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Bright, family-friendly playground on the property featuring red play structures, slides, and a safe mulch surface.",
      "link": "false",
      "alt_text": "Colorful outdoor playground with red structures, a green slide, and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/fcebad189a2adfcbcdd35d4b691bbe35.jpg"
    },
    {
      "id": "custom_1fcd9133-d8a7-4cfb-81f9-2970d6ffa010",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-4aa3-751d-b250-1a7d18ae0625.webp",
      "image_media": {
        "alt_text": "Apartments by the water with trees and a goose swimming.",
        "public_id": "019fce07-4aa3-751d-b250-1a7d18ae0625",
        "storage_key": "property/6767906449166340/019fce07-4aa3-751d-b250-1a7d18ae0625.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautiful waterfront apartments surrounded by lush greenery. Enjoy the serene environment and the tranquility of nature right outside your door.",
      "link": "false",
      "alt_text": "Lakeside brick community building with banners along a calm lake and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/407d42fdb768dfa1f91c9e4ef639844d.webp"
    },
    {
      "id": "custom_9e2b3142-fabc-454a-ac9b-89e50b210603",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-4e54-718b-ac7c-605cc77000ec.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with red doors and blooming trees.",
        "public_id": "019fce07-4e54-718b-ac7c-605cc77000ec",
        "storage_key": "property/6767906449166340/019fce07-4e54-718b-ac7c-605cc77000ec.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Charming brick apartment buildings featuring vibrant red doors, well-maintained landscaping, and blooming trees, creating a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Brick apartment building exterior with red doors, stairs, and flowering shrubbery along a walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f8743985/dms3rep/multi/5767906449162442/6767906449166340/dc7129a926a70137ad19888c3ca8ce1d.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1cc7b1c3-bd08-4a88-a7ab-dcbcb7b622b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Mi Guerrero",
      "poi_type": "Restaurants",
      "poi_address": "61 S Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Market selling cooking components alongside tacos, empanadas and pupusas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-61f8-775e-a1ff-fac5df85cd43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-61f8-775e-a1ff-fac5df85cd43",
        "storage_key": "property/6767906449166340/019fce07-61f8-775e-a1ff-fac5df85cd43.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://miguerrogrill.froogleorders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=533613485708609707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-guerrero",
      "poi_latitude": "37.5436111",
      "poi_longitude": "-77.3688889",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-222-8003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0iOGgUasYkRqwgFV6PGZwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_424b835b-8b64-4f00-ad61-1ea86055efc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Li's Garden",
      "poi_type": "Restaurants",
      "poi_address": "1237 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Casual joint doling out familiar Chinese dishes, including fried rice, egg rolls, and chicken wings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-61aa-77ec-8113-0ac68087bd4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-61aa-77ec-8113-0ac68087bd4a",
        "storage_key": "property/6767906449166340/019fce07-61aa-77ec-8113-0ac68087bd4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=870945610929913065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lis-garden",
      "poi_latitude": "37.5611488",
      "poi_longitude": "-77.3735908",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-343-9737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfYH-_wZsYkR6bwpLms4Fgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17ad3cf3-d35c-4a8c-a522-70c3acaeeabd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Jackie's Restaurant Southern Style Cooking",
      "poi_type": "Restaurants",
      "poi_address": "1241 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Soul food menu with seafood options plus live music, karaoke and an all-you-can-eat option.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-61fd-756f-8284-449c6738d518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-61fd-756f-8284-449c6738d518",
        "storage_key": "property/6767906449166340/019fce07-61fd-756f-8284-449c6738d518.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jackiesrestaurantrva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11681216154531369134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackies-restaurant-southern-style-cooking",
      "poi_latitude": "37.5613754",
      "poi_longitude": "-77.37362639999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-477-7493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWdLkfwZsYkRrpBl6zMEHKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4fac20ca-40ed-4508-9368-8f9755eacbc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Bojangles",
      "poi_type": "Restaurants",
      "poi_address": "11 S Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Southern-inspired fast-food chain known for fried chicken & biscuit, plus signature sides.",
      "poi_long_description": "Southern-inspired fast-food chain known for fried chicken & biscuit, plus signature sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-61d8-74ed-a3ed-d04bfaa0fbd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-61d8-74ed-a3ed-d04bfaa0fbd4",
        "storage_key": "property/6767906449166340/019fce07-61d8-74ed-a3ed-d04bfaa0fbd4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.bojangles.com/va/richmond/11-s.-laburnum-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15037854120939492824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bojangles",
      "poi_latitude": "37.5441371",
      "poi_longitude": "-77.36919879999999",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-222-0883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz-E_QQasYkR2BW-JqYwsdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31ddace5-df7f-4f3c-aa2b-bf1d3c63a65d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Taco Bell",
      "poi_type": "Restaurants",
      "poi_address": "1330 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_long_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6807-7329-b063-9a920671dee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6807-7329-b063-9a920671dee4",
        "storage_key": "property/6767906449166340/019fce07-6807-7329-b063-9a920671dee4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.tacobell.com/va/richmond/1330-n-laburnum-ave.html?utm_source=yext&utm_campaign=googlelistings&utm_medium=referral&utm_term=037336&utm_content=website&y_source=1_NTMwOTAxMjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12447992075605818247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-bell",
      "poi_latitude": "37.5631504",
      "poi_longitude": "-77.3770576",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-525-4628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbcvYQEZsYkRh7tcKdcmwKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f121db0e-f31a-42cf-a7f2-533ce5b3aa89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Popeyes Louisiana Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2318 E Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_long_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-68cc-7312-b799-894ad4125444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-68cc-7312-b799-894ad4125444",
        "storage_key": "property/6767906449166340/019fce07-68cc-7312-b799-894ad4125444.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.popeyes.com/store-locator/store/restaurant_83806",
      "poi_directions_map_url": "https://maps.google.com/?cid=7684665102676551833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popeyes-louisiana-kitchen",
      "poi_latitude": "37.5774757",
      "poi_longitude": "-77.39475139999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-321-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfc7gkWkXsYkRmWjgHjJqpWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b0cbb29f-cc8c-465b-8af7-4523f0139436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4443 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6945-736b-8d57-95f4729fe724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6945-736b-8d57-95f4729fe724",
        "storage_key": "property/6767906449166340/019fce07-6945-736b-8d57-95f4729fe724.webp",
        "width": 1275,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/va/white-oak-village?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=17591196625858588893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.5276801",
      "poi_longitude": "-77.3556189",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-236-4601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xZbnGoasYkR3fBZCiF8IPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8ec27453-b273-4c85-8937-b5baf404ce86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4409 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-691b-7149-8a54-bf2c68d2f61d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-691b-7149-8a54-bf2c68d2f61d",
        "storage_key": "property/6767906449166340/019fce07-691b-7149-8a54-bf2c68d2f61d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/va/richmond/richmond-laburnum-avenue/5350?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:richmond-va-5350_pl:locurl_rd:1296",
      "poi_directions_map_url": "https://maps.google.com/?cid=6262046466587510317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "37.530199",
      "poi_longitude": "-77.35838",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-222-0084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8bvJxUasYkRLUbwZxVC51Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_260a1b65-301a-41ab-9c10-785756f57ac7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "4435 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6eab-722c-a7bb-9d7b28d9822a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6eab-722c-a7bb-9d7b28d9822a",
        "storage_key": "property/6767906449166340/019fce07-6eab-722c-a7bb-9d7b28d9822a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/va/richmond/659/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=7761430534004321816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "37.5282706",
      "poi_longitude": "-77.3562204",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-222-3587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXmwvWoasYkRGK4y6PIjtms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d711b0a7-1fed-479e-9d70-a97116c8ed2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "4483 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6f67-77eb-a743-d76a0a6aff44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6f67-77eb-a743-d76a0a6aff44",
        "storage_key": "property/6767906449166340/019fce07-6f67-77eb-a743-d76a0a6aff44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/va/richmond/4483-south-laburnum-avenue?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601639&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=4344100633904688183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "37.5250717",
      "poi_longitude": "-77.3528144",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-222-0478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7c-731f-9c1a-ce4e810c1965.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7c-731f-9c1a-ce4e810c1965",
        "storage_key": "property/6767906449166340/019d026a-ea7c-731f-9c1a-ce4e810c1965.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJH-fVnkEasYkRNyxwsIJYSTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e182bcb9-191c-4d15-a3c2-367572190792",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "4501 S Laburnum Ave Unit 597, Richmond, VA 23231, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6fcb-74ad-a8c1-1d992611183b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6fcb-74ad-a8c1-1d992611183b",
        "storage_key": "property/6767906449166340/019fce07-6fcb-74ad-a8c1-1d992611183b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.qdoba.com/us/va/richmond/4501-s-laburnum-ave?utm_medium=organic&utm_source=google&utm_campaign=1279_2024_all_seo_google_maps_local&utm_content=website&utm_term=2576",
      "poi_directions_map_url": "https://maps.google.com/?cid=3739082955415482836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "37.5266346",
      "poi_longitude": "-77.35292319999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-226-1133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTZjhmoasYkR1PFBLyPk4zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0aafeed1-b25a-4401-b542-445cfd53a136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Publix Super Market at White Oak Village",
      "poi_type": "Restaurants",
      "poi_address": "4591 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7035-722c-97b7-3119982718df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7035-722c-97b7-3119982718df",
        "storage_key": "property/6767906449166340/019fce07-7035-722c-97b7-3119982718df.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1596&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=5730775627953657662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-white-oak-village",
      "poi_latitude": "37.5255869",
      "poi_longitude": "-77.3517956",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-226-1915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea79-7434-8046-fd1c33414148",
        "storage_key": "property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZazEEEasYkRPtekFxLOh08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9431a808-3191-4ddd-a43a-91f0691a6457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "4435 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-6eab-722c-a7bb-9d7b28d9822a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-6eab-722c-a7bb-9d7b28d9822a",
        "storage_key": "property/6767906449166340/019fce07-6eab-722c-a7bb-9d7b28d9822a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/va/richmond/659/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=7761430534004321816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "37.5282706",
      "poi_longitude": "-77.3562204",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-222-3587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7e-75e8-a65c-a1484ea2fe3c",
        "storage_key": "property/6767906449166340/019d026a-ea7e-75e8-a65c-a1484ea2fe3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXmwvWoasYkRGK4y6PIjtms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7b55ed0-c3c3-44c6-891d-54198aa61e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping",
      "poi_address": "1350 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-752b-778e-b52d-1739db317253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-752b-778e-b52d-1739db317253",
        "storage_key": "property/6767906449166340/019fce07-752b-778e-b52d-1739db317253.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/va/richmond/1350-n-laburnum-avenue?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050545693967926488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "37.5636328",
      "poi_longitude": "-77.37782899999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-956-6986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7a-768d-bf0b-951d91e0f625",
        "storage_key": "property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0fH1yeIZsYkR2ESGk_i0n-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1f23e23f-9dc5-4fc9-9c1c-9235c6ff2e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Nine Mile Convenience Store",
      "poi_type": "Shopping",
      "poi_address": "4917 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2870942977243724000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nine-mile-convenience-store",
      "poi_latitude": "37.545222",
      "poi_longitude": "-77.36668999999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-249-4476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efaa-75da-8ae7-3b569f8a73c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efaa-75da-8ae7-3b569f8a73c6",
        "storage_key": "property/6767906449166340/019d026a-efaa-75da-8ae7-3b569f8a73c6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJMUVGYhsasYkR4LgDSW2j1yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_607db07a-8a6f-4a72-8451-d2da47308b85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "5100 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-766d-7318-8b87-f873fd2c8fed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-766d-7318-8b87-f873fd2c8fed",
        "storage_key": "property/6767906449166340/019fce07-766d-7318-8b87-f873fd2c8fed.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5100-s-laburnum-ave-laburnum-square-richmond-va-23231/storeid=1976?WT.mc_id=LS_GOOGLE_RX_1976",
      "poi_directions_map_url": "https://maps.google.com/?cid=4876978380975811458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5167867",
      "poi_longitude": "-77.3504999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-222-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa2-7778-b41f-5ef508752db8",
        "storage_key": "property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzUkl1wasYkRgqtSh_-BrkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8adc4592-2c06-43c1-a538-aa4d2c76cd45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "5001 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "Familiar retail chain, selling electronics, home goods, clothing and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-76d6-738b-9801-b4ee889155f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-76d6-738b-9801-b4ee889155f0",
        "storage_key": "property/6767906449166340/019fce07-76d6-738b-9801-b4ee889155f0.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/7032-henrico-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5287426554768684370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.5444827",
      "poi_longitude": "-77.3643846",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-253-1528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7a-768d-bf0b-951d91e0f625",
        "storage_key": "property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ185CoBsasYkRUnX0BHC2YEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51028fab-2e60-4818-b893-d46077b3363f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping",
      "poi_address": "6009 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "Neighborhood chain grocery store specializing in food and produce, with some prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7782-72ba-bc04-63d48b0d83a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7782-72ba-bc04-63d48b0d83a9",
        "storage_key": "property/6767906449166340/019fce07-7782-72ba-bc04-63d48b0d83a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/va/richmond/6009-nine-mile-rd.?y_source=1_NTA0NjUyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6081283257127358119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "37.5498428",
      "poi_longitude": "-77.3423445",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-737-7375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea79-7434-8046-fd1c33414148",
        "storage_key": "property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdbplIcZsYkRp06b_-YOZVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1269b6aa-dd4b-4872-bad4-6e55d7c0b985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping",
      "poi_address": "4816 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7bbc-72ad-9335-c5a2e44d9573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7bbc-72ad-9335-c5a2e44d9573",
        "storage_key": "property/6767906449166340/019fce07-7bbc-72ad-9335-c5a2e44d9573.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/va/richmond/laburnum/029/00502?cid=loc_02900502_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10124820051061347280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "37.5197251",
      "poi_longitude": "-77.35194849999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-222-0240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea79-7434-8046-fd1c33414148",
        "storage_key": "property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X96SEMasYkR0JNDXjGWgow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fc742fd-e7b2-4cb1-b0c0-65b3901d1fbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Publix Super Market at White Oak Village",
      "poi_type": "Shopping",
      "poi_address": "4591 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7035-722c-97b7-3119982718df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7035-722c-97b7-3119982718df",
        "storage_key": "property/6767906449166340/019fce07-7035-722c-97b7-3119982718df.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1596&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=5730775627953657662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-white-oak-village",
      "poi_latitude": "37.5255869",
      "poi_longitude": "-77.3517956",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-226-1915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea79-7434-8046-fd1c33414148",
        "storage_key": "property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZazEEEasYkRPtekFxLOh08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e5062c8-77c7-42c1-860a-70218645b678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping",
      "poi_address": "5110 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Clean bakery stocking staples such as fresh groceries, meat, and produce.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7ca6-711d-9e3e-867c43e6dc5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7ca6-711d-9e3e-867c43e6dc5c",
        "storage_key": "property/6767906449166340/019fce07-7ca6-711d-9e3e-867c43e6dc5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lidl.com/stores/US01019",
      "poi_directions_map_url": "https://maps.google.com/?cid=13915123945187346984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "37.5156382",
      "poi_longitude": "-77.3502548",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea79-7434-8046-fd1c33414148",
        "storage_key": "property/6767906449166340/019d026a-ea79-7434-8046-fd1c33414148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVatqeVwasYkRKIpsroBzHME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd7f387e-8cfb-470d-94af-fa55645deabd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "La Fe Latino Market & Restaurant",
      "poi_type": "Shopping",
      "poi_address": "5000 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7dbb-71c7-b037-844e613331e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7dbb-71c7-b037-844e613331e3",
        "storage_key": "property/6767906449166340/019fce07-7dbb-71c7-b037-844e613331e3.webp",
        "width": 1242,
        "height": 700
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5152328454528741211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fe-latino-market--restaurant",
      "poi_latitude": "37.545992",
      "poi_longitude": "-77.36632209999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-716-2576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efaa-75da-8ae7-3b569f8a73c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efaa-75da-8ae7-3b569f8a73c6",
        "storage_key": "property/6767906449166340/019d026a-efaa-75da-8ae7-3b569f8a73c6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ2-kNJDQbsYkRW69SYm6_gEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c71e9ec9-05b5-49a3-95d4-94c9c41c1cb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "4521 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-7e58-729b-a4fb-a2eaeefa8223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-7e58-729b-a4fb-a2eaeefa8223",
        "storage_key": "property/6767906449166340/019fce07-7e58-729b-a4fb-a2eaeefa8223.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/richmond-east/2436",
      "poi_directions_map_url": "https://maps.google.com/?cid=1909153230887922965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.5313398",
      "poi_longitude": "-77.3566736",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-836-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-ea7a-768d-bf0b-951d91e0f625",
        "storage_key": "property/6767906449166340/019d026a-ea7a-768d-bf0b-951d91e0f625.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-9rthmoasYkRFS3dlL-sfho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27641c0c-47e4-4783-ad64-7da3267780ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Jacob L. Adams Elementary School",
      "poi_type": "Education",
      "poi_address": "600 S Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-824b-766c-af60-5f20f2c9d182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-824b-766c-af60-5f20f2c9d182",
        "storage_key": "property/6767906449166340/019fce07-824b-766c-af60-5f20f2c9d182.webp",
        "width": 768,
        "height": 768
      },
      "poi_business_url": "http://adams.henricoschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6372164332479725723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacob-l-adams-elementary-school",
      "poi_latitude": "37.5364405",
      "poi_longitude": "-77.36625939999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-226-8745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEV8aGxIasYkRm0De_7J5blg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_caaa62fc-4255-4800-a55c-9737f561b2ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Laburnum Elementary School",
      "poi_type": "Education",
      "poi_address": "500 Meriwether Ave, Richmond, VA 23222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://laburnum.henricoschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9589157890411244132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laburnum-elementary-school",
      "poi_latitude": "37.5967043",
      "poi_longitude": "-77.42834180000001",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-228-2720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn7Fq6f4WsYkRZKoYuUuIE4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ad6778c-0dae-46fb-a5d9-aecfa5bd189a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Linwood Holton Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 W Laburnum Ave, Richmond, VA 23227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-8351-74cf-a66a-dccc1858009a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-8351-74cf-a66a-dccc1858009a",
        "storage_key": "property/6767906449166340/019fce07-8351-74cf-a66a-dccc1858009a.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://lhes.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13066144469541836314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linwood-holton-elementary-school",
      "poi_latitude": "37.58535579999999",
      "poi_longitude": "-77.4613325",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-228-5310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFaJdVpgWsYkRGtb56ipFVLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_22d29cf0-19a3-442c-99bd-13e6a249abad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Martin Luther King Jr. Preschool",
      "poi_type": "Education",
      "poi_address": "900 Mosby St, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-853b-71f8-8556-b396f177a11d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-853b-71f8-8556-b396f177a11d",
        "storage_key": "property/6767906449166340/019fce07-853b-71f8-8556-b396f177a11d.webp",
        "width": 1280,
        "height": 548
      },
      "poi_business_url": "https://mlkps.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11422429195839875049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-jr-preschool",
      "poi_latitude": "37.5415972",
      "poi_longitude": "-77.4210294",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-648-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dIsPMoRsYkR6ScWwtWehJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ebb042c7-c4ee-4294-9820-17f407710dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Martin Luther King Jr. Middle School",
      "poi_type": "Education",
      "poi_address": "1000 Mosby St, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mlkms.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11232529096829951720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-jr-middle-school",
      "poi_latitude": "37.5421433",
      "poi_longitude": "-77.41993099999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-780-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ021-P9kQsYkR6N7JebP14Zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f308bbe4-1faf-4119-b42e-4642717633a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Armstrong High School",
      "poi_type": "Education",
      "poi_address": "2300 Cool Ln, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ahs.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17182746088923288914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armstrong-high-school",
      "poi_latitude": "37.5520819",
      "poi_longitude": "-77.4040672",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-780-4449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9kAUsoQsYkRUlUBoIdgde4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7316fa2-975a-40bc-8397-8c3dfa850365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Reynolds Community College (Downtown Campus)",
      "poi_type": "Education",
      "poi_address": "700 E Jackson St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-84e0-75a8-9b0c-54a378cb1a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-84e0-75a8-9b0c-54a378cb1a85",
        "storage_key": "property/6767906449166340/019fce07-84e0-75a8-9b0c-54a378cb1a85.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047220594730068864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reynolds-community-college-downtown-campus",
      "poi_latitude": "37.5457194",
      "poi_longitude": "-77.43130889999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-371-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8CSyQRsYkRgOtbHpV5iA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_acf0c978-8a92-49f5-9bd8-54403b4bebe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Virginia Commonwealth University",
      "poi_type": "Education",
      "poi_address": "Richmond, VA 23284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-8818-705e-b34e-78e4b0a097d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-8818-705e-b34e-78e4b0a097d5",
        "storage_key": "property/6767906449166340/019fce07-8818-705e-b34e-78e4b0a097d5.webp",
        "width": 900,
        "height": 599
      },
      "poi_business_url": "http://vcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1682113867784917192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-commonwealth-university",
      "poi_latitude": "37.5469205",
      "poi_longitude": "-77.45416449999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-828-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3Le1yMRsYkRyBAUiaYRWBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46b2e25c-e2eb-4731-be88-2918504ae6b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Virginia Union University",
      "poi_type": "Education",
      "poi_address": "1500 N Lombardy St, Richmond, VA 23220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-89f1-7472-84a4-3d67213f0298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-89f1-7472-84a4-3d67213f0298",
        "storage_key": "property/6767906449166340/019fce07-89f1-7472-84a4-3d67213f0298.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.vuu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=593211782889148504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-union-university",
      "poi_latitude": "37.5626214",
      "poi_longitude": "-77.4513784",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-257-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA9H16bQWsYkRWBCvO_mCOwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8601066-c083-4339-b360-6c28a96a5d69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Richmond Raceway",
      "poi_type": "Entertainment",
      "poi_address": "600 E Laburnum Ave, Richmond, VA 23222, USA",
      "poi_short_description": "3/4-mile, D-shaped racetrack hosting the Monster Energy NASCAR Cup Series and NASCAR Xfinity Series.",
      "poi_long_description": "3/4-mile, D-shaped racetrack hosting the Monster Energy NASCAR Cup Series and NASCAR Xfinity Series.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-8abe-7249-b5d0-feb541231687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-8abe-7249-b5d0-feb541231687",
        "storage_key": "property/6767906449166340/019fce07-8abe-7249-b5d0-feb541231687.webp",
        "width": 820,
        "height": 360
      },
      "poi_business_url": "http://www.richmondraceway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9453402611719025526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-raceway",
      "poi_latitude": "37.5883178",
      "poi_longitude": "-77.42195889999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 866-455-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dX8uh0XsYkRdjNDzpY7MYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ef0e844-fd1e-4181-93c7-50da420752bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Science Museum of Virginia",
      "poi_type": "Entertainment",
      "poi_address": "2500 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_long_description": "Kid-focused, hands-on exhibits about animals, the human body, the cosmos & the environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-8be7-7698-a184-71c48975d2b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-8be7-7698-a184-71c48975d2b7",
        "storage_key": "property/6767906449166340/019fce07-8be7-7698-a184-71c48975d2b7.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.smv.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474820232218678101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-of-virginia",
      "poi_latitude": "37.5610827",
      "poi_longitude": "-77.4657929",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-864-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f45b-715c-9dc0-2cfd97a5a2db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f45b-715c-9dc0-2cfd97a5a2db",
        "storage_key": "property/6767906449166340/019d026a-f45b-715c-9dc0-2cfd97a5a2db.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9jmx1QRsYkRVRN404AJXpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40e122db-895e-4d78-9977-22c9f9c5f259",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Virginia Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "200 N Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_long_description": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-8df8-726a-bb96-c7a584582cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-8df8-726a-bb96-c7a584582cb7",
        "storage_key": "property/6767906449166340/019fce07-8df8-726a-bb96-c7a584582cb7.webp",
        "width": 681,
        "height": 458
      },
      "poi_business_url": "https://vmfa.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4695707663755383770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-museum-of-fine-arts",
      "poi_latitude": "37.5560356",
      "poi_longitude": "-77.4747907",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-340-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f45b-715c-9dc0-2cfd97a5a2db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f45b-715c-9dc0-2cfd97a5a2db",
        "storage_key": "property/6767906449166340/019d026a-f45b-715c-9dc0-2cfd97a5a2db.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Bd8_wTsYkR2hM4wz2BKkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_37155389-1389-4501-a409-553fa0730ffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "The Byrd Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2908 W Cary St, Richmond, VA 23221, USA",
      "poi_short_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_long_description": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-90c4-77a8-a6af-42edf88f89ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-90c4-77a8-a6af-42edf88f89ad",
        "storage_key": "property/6767906449166340/019fce07-90c4-77a8-a6af-42edf88f89ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://byrdtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9894436379511868258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-byrd-theatre",
      "poi_latitude": "37.552441",
      "poi_longitude": "-77.4778413",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-358-3056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f459-738a-9b11-229409577a7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f459-738a-9b11-229409577a7c",
        "storage_key": "property/6767906449166340/019d026a-f459-738a-9b11-229409577a7c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1T2xOQTsYkRYsuB1XYZUIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a4196f4-241a-4d69-bfd7-f07566432f78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Lewis Ginter Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "1800 Lakeside Ave, Henrico, VA 23228, USA",
      "poi_short_description": "Year-round locale with 50 acres of themed gardens, dining options & a classical domed conservatory.",
      "poi_long_description": "Year-round locale with 50 acres of themed gardens, dining options & a classical domed conservatory.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-919f-734f-8edf-83cf499d3a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-919f-734f-8edf-83cf499d3a0d",
        "storage_key": "property/6767906449166340/019fce07-919f-734f-8edf-83cf499d3a0d.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.lewisginter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5246604299070095794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis-ginter-botanical-garden",
      "poi_latitude": "37.621294",
      "poi_longitude": "-77.47107849999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-262-9887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-ByrtgVsYkRskEc88-uz0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81739224-0214-4970-ae1f-d1479ae6ad96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Maymont",
      "poi_type": "Entertainment",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9311-77b9-a771-e511f42fe699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9311-77b9-a771-e511f42fe699",
        "storage_key": "property/6767906449166340/019fce07-9311-77b9-a771-e511f42fe699.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07754ee9-28b1-468f-9f43-3f73f372736c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "The Broadberry",
      "poi_type": "Entertainment",
      "poi_address": "2729 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_long_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9407-7679-846a-4dc2bea7107b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9407-7679-846a-4dc2bea7107b",
        "storage_key": "property/6767906449166340/019fce07-9407-7679-846a-4dc2bea7107b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebroadberry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6871247635338204732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadberry",
      "poi_latitude": "37.5616733",
      "poi_longitude": "-77.4695045",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-353-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizauXFURsYkRPJYTpFGTW18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4d081cdf-246a-4efd-8c62-207eeb55e78a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "The National",
      "poi_type": "Entertainment",
      "poi_address": "708 E Broad St, Richmond, VA 23219, USA",
      "poi_short_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_long_description": "Ornate, renovated 1920s theater now hosting medium-sized music shows & other performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9778-7160-8c34-739ccfa2df1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9778-7160-8c34-739ccfa2df1d",
        "storage_key": "property/6767906449166340/019fce07-9778-7160-8c34-739ccfa2df1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thenationalva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004828295590865461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national",
      "poi_latitude": "37.541897",
      "poi_longitude": "-77.43517",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-612-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UdhNiMRsYkRNWp4tVNK2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33fa9b0a-0c67-4e77-b39d-7ab0406fc99a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Hippodrome Theater",
      "poi_type": "Entertainment",
      "poi_address": "528 N 2nd St, Richmond, VA 23219, USA",
      "poi_short_description": "Entertainment venue & lounge housed in a renovated vaudeville theater with hints of 1914 glamour.",
      "poi_long_description": "Entertainment venue & lounge housed in a renovated vaudeville theater with hints of 1914 glamour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-97f7-74de-a37a-35a5337d7e8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-97f7-74de-a37a-35a5337d7e8e",
        "storage_key": "property/6767906449166340/019fce07-97f7-74de-a37a-35a5337d7e8e.webp",
        "width": 1248,
        "height": 830
      },
      "poi_business_url": "http://www.hippodromerichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14015178720581210976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hippodrome-theater",
      "poi_latitude": "37.5472611",
      "poi_longitude": "-77.4380472",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-308-2913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Vc48joRsYkRYFPbb8rqf8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_55f81b1a-e821-40d7-8f04-5806d064a13f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Gallery5",
      "poi_type": "Entertainment",
      "poi_address": "200 W Marshall St, Richmond, VA 23220, USA",
      "poi_short_description": "Housed in an 1867 firehouse, this dynamic venue offers art shows, performances & community events.",
      "poi_long_description": "Housed in an 1867 firehouse, this dynamic venue offers art shows, performances & community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-999b-729a-821f-b93c7cc840b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-999b-729a-821f-b93c7cc840b2",
        "storage_key": "property/6767906449166340/019fce07-999b-729a-821f-b93c7cc840b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://gallery5arts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15128766327566632949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallery5",
      "poi_latitude": "37.5476854",
      "poi_longitude": "-77.4428144",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUbklTkRsYkR9QeAvNEs9NE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c3cf3851-da10-4a26-8e45-17d009c6295c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Bon Secours Richmond Community Hospital",
      "poi_type": "Health",
      "poi_address": "1500 N 28th St, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9bb1-7209-997d-d9ad54b3f339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9bb1-7209-997d-d9ad54b3f339",
        "storage_key": "property/6767906449166340/019fce07-9bb1-7209-997d-d9ad54b3f339.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/richmond/richmond-community-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9604427351987486991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-richmond-community-hospital",
      "poi_latitude": "37.5401504",
      "poi_longitude": "-77.4070141",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-225-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f46c-72ee-ab39-b516b341f7f0",
        "storage_key": "property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqo4UsYkRD4FCSsrHSYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73e5bf03-d62a-4817-9860-39a262dbd597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Laburnum Medical Center",
      "poi_type": "Health",
      "poi_address": "4620 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9ede-7246-86e2-e5db4fc23aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9ede-7246-86e2-e5db4fc23aef",
        "storage_key": "property/6767906449166340/019fce07-9ede-7246-86e2-e5db4fc23aef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/primary-care-family-medicine/richmond/laburnum-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5018483097953376492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laburnum-medical-center",
      "poi_latitude": "37.5256261",
      "poi_longitude": "-77.3554271",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-226-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aUZh_oXsYkR7BjQ3Mk7pUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8960ec02-52fe-4be2-917f-e80b76f5b685",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health",
      "poi_address": "1205 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-9f63-744e-9fb8-92a4c1d0749c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-9f63-744e-9fb8-92a4c1d0749c",
        "storage_key": "property/6767906449166340/019fce07-9f63-744e-9fb8-92a4c1d0749c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/1205-n-laburnum-ave-richmond-va-23223/storeid=5986?WT.mc_id=LS_GOOGLE_RX_5986",
      "poi_directions_map_url": "https://maps.google.com/?cid=4979668434720051046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5611711",
      "poi_longitude": "-77.3742827",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-343-2012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa2-7778-b41f-5ef508752db8",
        "storage_key": "property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4Y17PwZsYkRZs-21g5WG0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a49d05cc-e36f-4313-af19-c71c70951698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health",
      "poi_address": "3715 Mechanicsville Tpke, Richmond, VA 23223, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a008-75e9-9260-ddb67d509053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a008-75e9-9260-ddb67d509053",
        "storage_key": "property/6767906449166340/019fce07-a008-75e9-9260-ddb67d509053.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3715+mechanicsville+tpke-richmond-va-23223/id=4488",
      "poi_directions_map_url": "https://maps.google.com/?cid=4617573946382459022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "37.5766894",
      "poi_longitude": "-77.3954706",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-329-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdWv9WkXsYkRjqA5DgrrFEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c007b0e5-5f7a-47f5-b4f8-7bd21f0d62d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health",
      "poi_address": "5001 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a281-763a-b8dc-281cff55afa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a281-763a-b8dc-281cff55afa7",
        "storage_key": "property/6767906449166340/019fce07-a281-763a-b8dc-281cff55afa7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/7032-henrico-va/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3253512351289159578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "37.5444827",
      "poi_longitude": "-77.3643846",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-253-0687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa2-7778-b41f-5ef508752db8",
        "storage_key": "property/6767906449166340/019d026a-efa2-7778-b41f-5ef508752db8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuwW3DRsasYkRmq_v4j7MJi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20499795-6ae2-41d9-b9f4-9c149207c233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Gold's Gym",
      "poi_type": "Health",
      "poi_address": "4346 S Laburnum Ave, Richmond, VA 23231, USA",
      "poi_short_description": "Large] family-friendly fitness center chain equipped with cardio and strength-training machines, plus personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a504-7210-b50c-56a608b2619a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a504-7210-b50c-56a608b2619a",
        "storage_key": "property/6767906449166340/019fce07-a504-7210-b50c-56a608b2619a.webp",
        "width": 580,
        "height": 326
      },
      "poi_business_url": "https://www.goldsgym.com/laburnum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13280945551766268269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym",
      "poi_latitude": "37.5289074",
      "poi_longitude": "-77.36075989999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-222-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5S-XWsasYkRbSlVJp1lT7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_11bc1f99-8a91-4e0a-b7b0-fd70b6aaf28a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "4951 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "Chain gym offering a variety of equipment, massage chairs, and tanning in a clean environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a5e8-7139-9b2c-34b0fed6c830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a5e8-7139-9b2c-34b0fed6c830",
        "storage_key": "property/6767906449166340/019fce07-a5e8-7139-9b2c-34b0fed6c830.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/richmond-eastgate-town-center-va?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4076633409632980259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.5434811",
      "poi_longitude": "-77.3665238",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-652-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31e3OxsasYkRI82ptHwckzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94829637-e123-4669-bc1d-0d8282b24623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Frank J. Thornton YMCA Aquatic Center",
      "poi_type": "Health",
      "poi_address": "3201 Watts Ln, Richmond, VA 23223, USA",
      "poi_short_description": "Indoor pool featuring a kids' zone and swim lessons and team options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a5c9-720a-938a-6708289914f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a5c9-720a-938a-6708289914f3",
        "storage_key": "property/6767906449166340/019fce07-a5c9-720a-938a-6708289914f3.webp",
        "width": 848,
        "height": 477
      },
      "poi_business_url": "https://www.ymcarichmond.org/locations/frank-j-thornton-ymca-aquatic-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10106081556996867068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-j-thornton-ymca-aquatic-center",
      "poi_latitude": "37.564695",
      "poi_longitude": "-77.3804334",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-918-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH61q5bsXsYkR_MPsu6EDQIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86c26739-45e2-4694-af76-9dd1cbe92b49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Eastern Henrico Recreation Center",
      "poi_type": "Health",
      "poi_address": "1440 N Laburnum Ave, Richmond, VA 23223, USA",
      "poi_short_description": "Fitness center with an indoor court and a track, plus a playground and splash parks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-a9ef-77f1-bc57-2e6121c4d39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-a9ef-77f1-bc57-2e6121c4d39f",
        "storage_key": "property/6767906449166340/019fce07-a9ef-77f1-bc57-2e6121c4d39f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://henrico.gov/rec/places/ehrc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2725637937803822077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-henrico-recreation-center",
      "poi_latitude": "37.5662322",
      "poi_longitude": "-77.3801162",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-652-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeySwWRUXsYkR_QMgbUNp0yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07b17db7-f9fe-4d7a-8f9c-3ec3c10d25d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Midtown Yoga",
      "poi_type": "Health",
      "poi_address": "3526 W Cary St Unit A140, Richmond, VA 23221, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-ab71-7412-8513-f0e401486c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-ab71-7412-8513-f0e401486c57",
        "storage_key": "property/6767906449166340/019fce07-ab71-7412-8513-f0e401486c57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://midtownyogastudios.com/richmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=15224894398813960060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-yoga",
      "poi_latitude": "37.55574",
      "poi_longitude": "-77.4875452",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-533-7569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT-Xc4QcTsYkRfPcjcMqwSdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a2b84bb-cef2-47f6-a59b-41f8ba084eb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Chimborazo Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3215 E Broad St, Richmond, VA 23223, USA",
      "poi_short_description": "City park with a visitor center for the Richmond National Battlefield & miniature Statue of Liberty.",
      "poi_long_description": "City park with a visitor center for the Richmond National Battlefield & miniature Statue of Liberty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-acad-73ad-8977-2ed40efb6439.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-acad-73ad-8977-2ed40efb6439",
        "storage_key": "property/6767906449166340/019fce07-acad-73ad-8977-2ed40efb6439.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/chimborazo-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12111405533705259491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chimborazo-park",
      "poi_latitude": "37.5257497",
      "poi_longitude": "-77.4117976",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4-FwO8QsYkR48kz9ylbFKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86df4140-1b2e-4649-a303-9c8382689f79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Church Hill Dog Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3600 E Grace St, Richmond, VA 23223, USA",
      "poi_short_description": "Fenced space with 2 runs for large and small dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-ad45-7072-82aa-50c7bb514ac7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-ad45-7072-82aa-50c7bb514ac7",
        "storage_key": "property/6767906449166340/019fce07-ad45-7072-82aa-50c7bb514ac7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4748026789481023076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "church-hill-dog-park",
      "poi_latitude": "37.5242048",
      "poi_longitude": "-77.41009609999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSUxJMfAQsYkRZAYOezVh5EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5f29685b-8f77-49ee-a46b-be02ec854ab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Libby Hill Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "2801 E Franklin St, Richmond, VA 23223, USA",
      "poi_short_description": "One of the earliest city parks, this elevated green space offers scenic views, benches & tall trees.",
      "poi_long_description": "One of the earliest city parks, this elevated green space offers scenic views, benches & tall trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b175-72e8-941a-bdae08f61de0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b175-72e8-941a-bdae08f61de0",
        "storage_key": "property/6767906449166340/019fce07-b175-72e8-941a-bdae08f61de0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.virginia.org/listing/libby-hill-park/6882/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498133758744061044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "libby-hill-park",
      "poi_latitude": "37.526515",
      "poi_longitude": "-77.41746800000001",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-646-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVKgouQQsYkRdOSF8YVLTUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3afe17e3-824e-4efd-960c-24a2727153a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Great Shiplock Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "2803 Dock St, Richmond, VA 23223, USA",
      "poi_short_description": "Family-friendly park featuring scenic riverside trails, a canal tour and a locks system.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b22f-77fb-a8df-dbc866805f15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b22f-77fb-a8df-dbc866805f15",
        "storage_key": "property/6767906449166340/019fce07-b22f-77fb-a8df-dbc866805f15.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-great-shiplock-park-chapel-island/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11527419003180666532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-shiplock-park",
      "poi_latitude": "37.52659149999999",
      "poi_longitude": "-77.42128009999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZqCx_wQsYkRpM6rLYKe-Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f00448a5-723e-4c2e-8684-a93540fc5d89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "697 Tredegar St",
      "poi_type": "Outdoor Attractions",
      "poi_address": "697 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=697+Tredegar+St,+Richmond,+VA+23219,+USA&ftid=0x89b111143926eda9:0xafbaf79c28abbcae&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "697-tredegar-st",
      "poi_latitude": "37.5352587",
      "poi_longitude": "-77.4421125",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "Eig2OTcgVHJlZGVnYXIgU3QsIFJpY2htb25kLCBWQSAyMzIxOSwgVVNBIjESLwoUChIJqe0mORQRsYkR6V8hzN_KSgwQuQUqFAoSCb-6EF9rEbGJEXzCmHFlz5VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2cf8288-8fc0-4c1b-8dfe-82467ac4d10f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Belle Isle Suspension Bridge",
      "poi_type": "Outdoor Attractions",
      "poi_address": "300 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "Suspension bridge for pedestrians with metal cables and views of the James River, plus paths for biking and jogging.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b3ff-746f-8bcf-a3303adf3d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b3ff-746f-8bcf-a3303adf3d81",
        "storage_key": "property/6767906449166340/019fce07-b3ff-746f-8bcf-a3303adf3d81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12002507654618820215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belle-isle-suspension-bridge",
      "poi_latitude": "37.5328769",
      "poi_longitude": "-77.4495357",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4mwYWsRsYkRdy52rx55kaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8fe2c83-ff54-422b-aafc-6f591e718a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Jefferson Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "E Marshall St, Richmond, VA 23223, USA",
      "poi_short_description": "Family-friendly hangout featuring fountain areas, a playground and exercise equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b534-716d-ad6e-f3792711cb59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b534-716d-ad6e-f3792711cb59",
        "storage_key": "property/6767906449166340/019fce07-b534-716d-ad6e-f3792711cb59.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2992648855015393978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-park",
      "poi_latitude": "37.5353664",
      "poi_longitude": "-77.4216352",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-426-0620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95CUYeAQsYkRugqsJEcGiCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40941c0b-3091-4d03-9a9a-ab44f86f8cc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Byrd Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "600 S Arthur Ashe Blvd, Richmond, VA 23220, USA",
      "poi_short_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_long_description": "Picturesque city park offering 3 lakes, a walking path, picnic areas, athletic fields & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b841-7051-8559-5b1a5d3de10b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b841-7051-8559-5b1a5d3de10b",
        "storage_key": "property/6767906449166340/019fce07-b841-7051-8559-5b1a5d3de10b.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/byrd-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837632018604371955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byrd-park",
      "poi_latitude": "37.5427152",
      "poi_longitude": "-77.4795668",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-646-5733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f457-7275-af22-436a588d1487",
        "storage_key": "property/6767906449166340/019d026a-f457-7275-af22-436a588d1487.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7oHsZILsYkR8y8Y4k1uKLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30c4aeb4-773e-4a14-b4ee-5fa99a534661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "White Oak Village + Office Max",
      "poi_type": "Transit",
      "poi_address": "Sandston, VA 23231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11941639936995374737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-oak-village--office-max",
      "poi_latitude": "37.529778",
      "poi_longitude": "-77.354478",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-faf0-74f8-aaf2-f3e2cf95c041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-faf0-74f8-aaf2-f3e2cf95c041",
        "storage_key": "property/6767906449166340/019d026a-faf0-74f8-aaf2-f3e2cf95c041.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJM5NF8T8asYkRkTY60EA6uaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3b9fae5-5295-4373-83ea-398548645fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "GRTC",
      "poi_type": "Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b880-7427-bc7b-bdac7bc18e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b880-7427-bc7b-bdac7bc18e34",
        "storage_key": "property/6767906449166340/019fce07-b880-7427-bc7b-bdac7bc18e34.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2c63c9cd-334d-4ff3-bd6c-91916241aff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Eastern Government Center",
      "poi_type": "Transit",
      "poi_address": "3820 Nine Mile Rd, Richmond, VA 23223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-ba32-735f-9c54-af7b4bc64ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-ba32-735f-9c54-af7b4bc64ecc",
        "storage_key": "property/6767906449166340/019fce07-ba32-735f-9c54-af7b4bc64ecc.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://henrico.us/locations/eastern-government-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12114071812942637823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-government-center",
      "poi_latitude": "37.5432649",
      "poi_longitude": "-77.3823007",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-fbc1-7139-90a7-1bd5ab968435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-fbc1-7139-90a7-1bd5ab968435",
        "storage_key": "property/6767906449166340/019d026a-fbc1-7139-90a7-1bd5ab968435.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYKSPqkQsYkR_6oEeiHUHag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd13b48f-a4d8-4b96-962d-ec80cf2e7848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Glenside Park & Ride (Henrico County)",
      "poi_type": "Transit",
      "poi_address": "4069-4099 Crockett St, Henrico, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-bdb8-771c-a34f-6b57469a9125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-bdb8-771c-a34f-6b57469a9125",
        "storage_key": "property/6767906449166340/019fce07-bdb8-771c-a34f-6b57469a9125.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8413788077024707651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenside-park--ride-henrico-county",
      "poi_latitude": "37.6144744",
      "poi_longitude": "-77.5013764",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-fbca-749a-90bd-9b3702065304.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-fbca-749a-90bd-9b3702065304",
        "storage_key": "property/6767906449166340/019d026a-fbca-749a-90bd-9b3702065304.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6qnFLEVsYkRQ4R5iq3Hw3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d01fd60b-3567-452b-8b46-820b0e4f694b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Richmond International Airport",
      "poi_type": "Transit",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-bea7-7199-8c11-6fdfe773227b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-bea7-7199-8c11-6fdfe773227b",
        "storage_key": "property/6767906449166340/019fce07-bea7-7199-8c11-6fdfe773227b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-fc11-769f-88b4-1ca49fca7247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-fc11-769f-88b4-1ca49fca7247",
        "storage_key": "property/6767906449166340/019d026a-fc11-769f-88b4-1ca49fca7247.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ece7ef8-b881-47ff-96d7-f90c56bf3df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Richmond Staples Mill Road Amtrak Station",
      "poi_type": "Transit",
      "poi_address": "Dumbarton, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-bf81-71af-b1ae-8bb5894248bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-bf81-71af-b1ae-8bb5894248bf",
        "storage_key": "property/6767906449166340/019fce07-bf81-71af-b1ae-8bb5894248bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11564533009259022131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-staples-mill-road-amtrak-station",
      "poi_latitude": "37.617693",
      "poi_longitude": "-77.496943",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXNmZLcVsYkRM8cpGoB5faA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_997b885e-01a4-4ae1-8d82-678412c7af69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Richmond Main Street Station",
      "poi_type": "Transit",
      "poi_address": "1500 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-c0c2-769b-8a55-3d6c181ecad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-c0c2-769b-8a55-3d6c181ecad8",
        "storage_key": "property/6767906449166340/019fce07-c0c2-769b-8a55-3d6c181ecad8.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvm.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11973413221483929113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-main-street-station",
      "poi_latitude": "37.5351005",
      "poi_longitude": "-77.4287069",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8r0xR4RsYkRGd6DF-MbKqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97ab6e35-5148-4ca9-9f7d-706ce2855d3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "GRTC",
      "poi_type": "Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-b880-7427-bc7b-bdac7bc18e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-b880-7427-bc7b-bdac7bc18e34",
        "storage_key": "property/6767906449166340/019fce07-b880-7427-bc7b-bdac7bc18e34.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ea5b0a5-011c-4045-b2a5-d0ad09f7d5f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "RideFinders",
      "poi_type": "Transit",
      "poi_address": "1013 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-c480-70aa-aff4-92c4f74ddf16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-c480-70aa-aff4-92c4f74ddf16",
        "storage_key": "property/6767906449166340/019fce07-c480-70aa-aff4-92c4f74ddf16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridefinders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17457098239546745791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridefinders",
      "poi_latitude": "37.5372101",
      "poi_longitude": "-77.43498939999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-643-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7iNPRgRsYkRv-NHcVsSRPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_292bad8f-9ef3-4480-9117-f6780f525f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "University Student Commons",
      "poi_type": "Major Employers",
      "poi_address": "907 Floyd Ave, Richmond, VA 23284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-c576-71ff-9c2f-b9090110b412.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-c576-71ff-9c2f-b9090110b412",
        "storage_key": "property/6767906449166340/019fce07-c576-71ff-9c2f-b9090110b412.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://usca.vcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3051156513130157075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-student-commons",
      "poi_latitude": "37.5464877",
      "poi_longitude": "-77.45331879999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-828-1981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa9-7248-a9de-0eb3a2e2c664",
        "storage_key": "property/6767906449166340/019d026a-efa9-7248-a9de-0eb3a2e2c664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvx5XFNsHsYkRExQ-167iVyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85ec2aed-c742-403f-8384-8b9fa1454987",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "VCU Medical Center Main Hospital",
      "poi_type": "Major Employers",
      "poi_address": "1250 E Marshall St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-c68b-733c-906f-6bddefd7867b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-c68b-733c-906f-6bddefd7867b",
        "storage_key": "property/6767906449166340/019fce07-c68b-733c-906f-6bddefd7867b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vcuhealth.org/locations/location-details?practice=10",
      "poi_directions_map_url": "https://maps.google.com/?cid=16171533531014720203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-medical-center-main-hospital",
      "poi_latitude": "37.5404994",
      "poi_longitude": "-77.4304837",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-828-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f46c-72ee-ab39-b516b341f7f0",
        "storage_key": "property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHcj3gSERsYkRy2pz5RDUbOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2d875cf8-70cf-479a-95dc-55829ea13ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "410 Westhampton Way",
      "poi_type": "Major Employers",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-c90a-75db-a269-d41ad3138b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-c90a-75db-a269-d41ad3138b5b",
        "storage_key": "property/6767906449166340/019fce07-c90a-75db-a269-d41ad3138b5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11539126774048606380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "410-westhampton-way",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkRrMhdAao2I6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8aa44bc8-3e5e-4a8c-b4d3-ee5aed7c0908",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Richmond International Airport",
      "poi_type": "Major Employers",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-bea7-7199-8c11-6fdfe773227b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-bea7-7199-8c11-6fdfe773227b",
        "storage_key": "property/6767906449166340/019fce07-bea7-7199-8c11-6fdfe773227b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-fc11-769f-88b4-1ca49fca7247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-fc11-769f-88b4-1ca49fca7247",
        "storage_key": "property/6767906449166340/019d026a-fc11-769f-88b4-1ca49fca7247.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_766416a5-9ebd-43eb-a883-38a21cbd50e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Altria Headquarters",
      "poi_type": "Major Employers",
      "poi_address": "6601 W Broad St, Richmond, VA 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-cb4b-70e7-8a34-98ff7ed5acda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-cb4b-70e7-8a34-98ff7ed5acda",
        "storage_key": "property/6767906449166340/019fce07-cb4b-70e7-8a34-98ff7ed5acda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.altria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996391984863159021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-headquarters",
      "poi_latitude": "37.6007695",
      "poi_longitude": "-77.5169708",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITmtbfgUsYkR7aJIUg7jHdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab815005-accd-4bc0-a409-bc67f3dc8c3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "CarMax Home Office",
      "poi_type": "Major Employers",
      "poi_address": "12800 Tuckahoe Creek Pkwy, Richmond, VA 23238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-cc84-764c-b006-ae0c7d5adbc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-cc84-764c-b006-ae0c7d5adbc3",
        "storage_key": "property/6767906449166340/019fce07-cc84-764c-b006-ae0c7d5adbc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carmax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609920891388220952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carmax-home-office",
      "poi_latitude": "37.6393791",
      "poi_longitude": "-77.67147969999999",
      "poi_miles_from_property": "37.3 mi",
      "poi_walking_minutes": "13 hours 47 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 804-747-0422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJocjWXZdpsYkRGNYQBzlNOCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d038952e-5c01-4803-8d7a-7609867bdccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Dominion Energy Virginia",
      "poi_type": "Major Employers",
      "poi_address": "120 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-ce42-70a9-a73e-84166789dc28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-ce42-70a9-a73e-84166789dc28",
        "storage_key": "property/6767906449166340/019fce07-ce42-70a9-a73e-84166789dc28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dominionenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11041679550737667097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominion-energy-virginia",
      "poi_latitude": "37.533753",
      "poi_longitude": "-77.4537127",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 866-366-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-efa4-71d9-8e76-7b4ac6170a5b",
        "storage_key": "property/6767906449166340/019d026a-efa4-71d9-8e76-7b4ac6170a5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2CeDWwRsYkRGdRp0QztO5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_594608e0-d2b5-4f5e-a0c7-cb3471c6d6d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Bon Secours St. Mary's Hospital",
      "poi_type": "Major Employers",
      "poi_address": "5801 Bremo Rd, Richmond, VA 23226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-d1b0-7151-b082-5bc6b56b10dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-d1b0-7151-b082-5bc6b56b10dd",
        "storage_key": "property/6767906449166340/019fce07-d1b0-7151-b082-5bc6b56b10dd.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/richmond/st-marys-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15600236463638216957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-st-marys-hospital",
      "poi_latitude": "37.5842533",
      "poi_longitude": "-77.5127366",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-285-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f46c-72ee-ab39-b516b341f7f0",
        "storage_key": "property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUGmEmEUsYkR_YBA-2gsf9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6b978558-b76e-4d8a-8ca1-3a99565355f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Major Employers",
      "poi_address": "7101 Jahnke Rd E, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-d0fb-7448-8148-3d1378ee462a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-d0fb-7448-8148-3d1378ee462a",
        "storage_key": "property/6767906449166340/019fce07-d0fb-7448-8148-3d1378ee462a.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-f46c-72ee-ab39-b516b341f7f0",
        "storage_key": "property/6767906449166340/019d026a-f46c-72ee-ab39-b516b341f7f0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4284b7da-d667-49ae-860b-be4b1ec669ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "poi_name": "Henrico County",
      "poi_type": "Major Employers",
      "poi_address": "4301 E Parham Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fce07-d291-765f-94ab-896308338db5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce07-d291-765f-94ab-896308338db5",
        "storage_key": "property/6767906449166340/019fce07-d291-765f-94ab-896308338db5.webp",
        "width": 572,
        "height": 380
      },
      "poi_business_url": "https://henrico.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14441272984807831430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henrico-county",
      "poi_latitude": "37.6288733",
      "poi_longitude": "-77.5152853",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019d026a-fbc1-7139-90a7-1bd5ab968435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026a-fbc1-7139-90a7-1bd5ab968435",
        "storage_key": "property/6767906449166340/019d026a-fbc1-7139-90a7-1bd5ab968435.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVkK9J8VsYkRhnfqO0S1acg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_edcdb6c8-78ee-4426-91e0-c8ce2ea7c8e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4d2457ad-af2b-47d0-a5ed-dedac3fc8baa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_dd187217-5ff8-4924-ba3e-7c3c9243848d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f9d654bf-18e0-4819-a0fe-dd6e38f857d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_22b01249-399e-4f7d-a19a-0519d669b517",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_26f32fce-bb04-41eb-b4e9-b9e393f33261",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_79c57e28aaf126bad46fb33b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "rating": "5",
      "name": "Crystal Eastman",
      "text": "Pointe at River City, I want to give a huge thank-you to Miss Z, the Maintenance Manager for promptly addressing the issues I had in my apartment. From day one of moving in, I had ongoing concerns that I repeatedly called, emailed, and even stopped by the rental office about, but nothing was getting resolved — until I reached out directly to the maintenance department.\n\nMiss Z immediately took action and made sure everything that needed attention was handled. She was professional, polite, courteous, kind, friendly, and very helpful throughout the entire process.\nA big thank-you also to Mr. Ethan, ans team, who came to inspect and repair everything. He was professional, polite, funny, and efficient, and made sure all my apartment issues were completely fixed or replaced.\n\nThe customer service from the maintenance department was truly a 9 out of 10 experience. If you’re considering moving to Pointe at RiverCity, don’t let any initial issues discourage you — the maintenance team will take care of your needs quickly and kindly and efficiently.",
      "date": "2025-10-09",
      "title": "false"
    },
    {
      "id": "ec_01d93e98b6602f0d1e8804f9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "rating": "5",
      "name": "leslie Kithcart",
      "text": "I have to give a big shout-out to the maintenance department! While I was enjoying my breakfast by the window, I spotted one of the maintenance workers in a white pickup truck. He got out to tidy up the furniture and debris that had gathered next to the trash dumpster. It was nice to see him taking the time to ensure everything was cleaned up and put away properly. Great job!",
      "date": "2025-10-21",
      "title": "false"
    },
    {
      "id": "ec_69186e19142590a8c66ce819",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "rating": "5",
      "name": "Heaven Davis",
      "text": "I’ve been here at pointe at river city for about two years and half and I must say I have no complaints ! The area is quiet and is located near a lot of store that’s walking distance. Outside of minor things that needed to be done to the apartment, which they fixed in a timely manner my time here has been satisfying. The staff here is great and is always willing to assist. They have good payment options like flex to help assist with rental payments. I’ve been working with Sandy the property to manger on multiple occasions and I must say she’s great !! She goes above and beyond to help her residents to the best of her ability. I would recommend anyone looking to move to come apply with Pointe at River City.",
      "date": "2025-06-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9cdca5c7-80f4-4670-b851-3221b38011fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/019fa582-4b55-7753-bcf9-5986988baf9e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa582-4b55-7753-bcf9-5986988baf9e",
        "storage_key": "property/6767906449166340/019fa582-4b55-7753-bcf9-5986988baf9e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Pointe at River City",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=634d9456e0032e1d3080fafb&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_4fc5021905aba69e10d8d277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396315",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cb2b8b2c92521549763a1e54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396318",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c6af53aff054de3b567ef950",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396320",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1922ed31dd124344f901d515",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396321",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "350.00 / 100.00",
      "amount_type": "text",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fd6cc241f1c8514ad22fdd04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396322",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 99,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1f4eeb7ce49627402cb50ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396323",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4b69bf98b9bfefaedcb23c17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "396324",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_2d721e4003fcf00822a9d71e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "540996",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0f2cc0af68eb491efaab1a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "543043",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_93c9234db3ae8cbcb2ae3e99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "543054",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6b8a3224e67d36269d0413db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "543058",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ccba2f56180f65b65315b6ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "835100",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fdabb76b9f6c4c0a6e40fd3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "835102",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_380f435bf25fb5f800617c75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "engrain",
      "external_id": "835124",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1320-8dbe-708c-b213-c58400650e72",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-pointe-at-river-city-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340"
    },
    {
      "lead_collector_id": "019c3043-8e7a-773a-a4a5-0e8b2a144330",
      "lead_source": "FACEBOOK_ADS",
      "name": "pointe-at-river-city",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340"
    },
    {
      "lead_collector_id": "019c3043-8eec-76bf-8134-9b5fbfc4fa2c",
      "lead_source": "LANDING_PAGE",
      "name": "pointe-at-river-city",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-richmond-va-343",
      "search_query": "pet friendly apartments in Richmond VA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Richmond, VA",
      "h2_subtitle": "Discover pet-friendly living at Pointe at River City. Our Richmond, VA apartments welcome your furry friends with open arms.",
      "page_copy": "Explore a dynamic lifestyle at Pointe at River City, where our pet-friendly apartments in Richmond, VA, offer a welcoming space for you and your furry companions. Nestled in a tranquil setting, our community ensures your pets feel at home, complete with expansive outdoor spaces perfect for walks and playtime. \n\nOur community features spacious two-bedroom layouts with modern finishes, ideal for both you and your pets. Take advantage of our pet-friendly policies that make living with pets hassle-free. Whether you’re lounging by the swimming pool or enjoying the high-speed internet, Pointe at River City provides a perfect blend of convenience and comfort in a pet-friendly environment. Experience hassle-free living with flexible rent payments and dedicated 24-hour maintenance service in a vibrant Richmond, VA neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Richmond, VA",
      "seo_description": "Find welcoming pet friendly apartments in Richmond, VA at Pointe at River City. Perfect for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-upgraded-kitchens-henrico-county-917",
      "search_query": "apartments with upgraded kitchens Henrico County",
      "category": "Amenity",
      "h1_title": "Apartments with Upgraded Kitchens",
      "h2_subtitle": "Pointe at River City in Henrico County offers stylish apartments featuring upgraded kitchens. Experience modern living today!",
      "page_copy": "Discover the elegance of Pointe at River City, where stylish apartments with upgraded kitchens await you in Henrico County. Perfect for those who love cooking or entertaining, these kitchens feature modern finishes that elevate your living experience. \n\nLocated in beautiful Richmond, VA, our community showcases spacious two-bedroom apartments with additional comforts like hardwood flooring and vaulted ceilings. Whether you're hosting a dinner party or simply enjoying a quiet night in, our upgraded kitchens provide the ideal setting. Come home to Pointe at River City and enjoy convenience, style, and luxury in every corner of your new apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Upgraded Kitchens",
      "seo_description": "Explore apartments with upgraded kitchens in Henrico County at Pointe at River City, offering a modern lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "pool-access-apartments-richmond-23223-844",
      "search_query": "pool access apartments Richmond 23223",
      "category": "Amenity",
      "h1_title": "Pool Access Apartments in Richmond 23223",
      "h2_subtitle": "Experience the luxury of pool access at Pointe at River City. Located in Richmond 23223, these apartments offer a refreshing lifestyle.",
      "page_copy": "Immerse yourself in the comfort of pool access apartments at Pointe at River City, located in the vibrant Richmond 23223 area. Our community perfectly blends relaxation and activity, providing you with a refreshing swimming pool ideal for unwinding after a busy day.\n\nSituated in the heart of Henrico County, our spacious two-bedroom apartments offer more than just a place to live; they provide a serene escape. Enjoy modern amenities like vaulted ceilings and more, all designed for your convenience. With flexible rent payments and round-the-clock maintenance, Pointe at River City ensures that luxurious leisure and effortless living are always at your fingertips.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Access Apartments in Richmond 23223",
      "seo_description": "Discover pool access apartments in Richmond 23223 at Pointe at River City. Dive into comfort and style today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "dog-park-apartments-river-city-richmond-273",
      "search_query": "dog park apartments near River City Richmond",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near River City",
      "h2_subtitle": "Pointe at River City offers dog-friendly apartments near River City in Richmond. Enjoy nearby amenities perfect for pet owners.",
      "page_copy": "Welcome to Pointe at River City, where our dog park apartments near River City in Richmond provide the perfect environment for you and your canine companions. Our community embraces pet-friendly living with ample outdoor spaces ideal for playtime.\n\nLocated conveniently in Henrico County, our expansive two-bedroom apartments come with modern amenities like hardwood flooring and vaulted ceilings, ensuring a comfortable stay for both you and your pets. Enjoy the convenience of nearby pet amenities and explore the seamless blend of style and comfort we offer. Make Pointe at River City your home and give your furry friends the lifestyle they deserve in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near River City",
      "seo_description": "Discover dog park apartments near River City Richmond at Pointe at River City, ideal for pet lovers!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "dog-park-community-henrico-county-702",
      "search_query": "dog park community Henrico County",
      "category": "Amenity",
      "h1_title": "Dog Park Community in Henrico County",
      "h2_subtitle": "Explore our dog-friendly community at Pointe at River City in Henrico County. Perfect for pet owners seeking comfort and convenience.",
      "page_copy": "Pointe at River City proudly presents a dog park community in the heart of Henrico County, where pets are more than welcome. Our dedicated pet-friendly amenities allow you and your furry friends to enjoy the great outdoors right at home, offering spacious areas perfect for play and exercise.\n\nLocated in Richmond, VA, our community offers more than just pet-friendly spaces. Our two-bedroom apartments feature contemporary comforts like upgraded kitchens, vaulted ceilings, and reliable high-speed internet. Experience the perfect blend of modern living and pet-friendly conveniences at Pointe at River City, where every family member, including your pets, feels at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Community in Henrico County",
      "seo_description": "Discover dog park living at Pointe at River City, a pet-friendly community in Henrico County offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-with-pool-richmond-va-813",
      "search_query": "two-bedroom apartments with pool Richmond VA",
      "category": "Amenity",
      "h1_title": "Two-Bedroom Apartments with Pool in Richmond",
      "h2_subtitle": "Pointe at River City offers spacious two-bedroom apartments with a pool in Richmond, VA. Enjoy upscale amenities and serene environments.",
      "page_copy": "Discover the perfect blend of comfort and luxury at Pointe at River City, offering two-bedroom apartments with a pool in Richmond, VA. Our modern community provides a refreshing swimming pool, ideal for relaxation and leisure after a long day.\n\nLocated in the desirable Henrico County, our spacious apartments feature sophisticated amenities, including vaulted ceilings, hardwood flooring, and a third-bedroom loft option. With high-speed internet and flex rent payments, convenience is always at hand. Experience a vibrant lifestyle at Pointe at River City, where modern living meets tranquil outdoor spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments with Pool in Richmond",
      "seo_description": "Explore two-bedroom apartments with a pool in Richmond, VA at Pointe at River City. Experience luxury and comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-with-stainless-steel-appliances-richmond-231",
      "search_query": "apartments with stainless steel appliances Richmond",
      "category": "Amenity",
      "h1_title": "Richmond Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover Pointe at River City's Richmond apartments featuring modern stainless steel appliances. Enjoy stylish living with top-notch amenities.",
      "page_copy": "Uncover a new standard of living at Pointe at River City, where our apartments with stainless steel appliances redefine comfort and style in Richmond. Our upgraded kitchen appliances provide a sleek, modern feel, perfect for home chefs and relaxed dining experiences.\n\nNestled in the heart of Henrico County, our community offers not only stylish interiors but also enriching amenities like a refreshing swimming pool and high-speed internet. Alongside vaulted ceilings and hardwood flooring, you'll find a welcoming, pet-friendly atmosphere designed to enhance your lifestyle. Explore all that our thoughtfully designed community has to offer today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apartments with Stainless Steel Appliances",
      "seo_description": "Explore Pointe at River City's Richmond apartments with stainless steel appliances, offering contemporary living and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "high-speed-internet-apartments-richmond-611",
      "search_query": "high-speed internet apartments Richmond",
      "category": "Amenity",
      "h1_title": "Richmond Apartments with High-Speed Internet",
      "h2_subtitle": "Enjoy high-speed internet at Pointe at River City in Richmond. Experience seamless connectivity in our modern apartment community.",
      "page_copy": "Stay connected with ease at Pointe at River City, where our high-speed internet apartments in Richmond cater to all your online needs. Whether working from home or streaming your favorite shows, our reliable internet ensures a smooth, uninterrupted experience.\n\nSituated in the vibrant Henrico County, our spacious two-bedroom apartments offer more than just connectivity. Enjoy modern comforts like updated kitchens, vaulted ceilings, and a serene swimming pool. With pet-friendly spaces and 24-hour maintenance, Pointe at River City is designed for a lively, convenient lifestyle. Join our community and enjoy a seamless living experience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richmond Apartments with High-Speed Internet",
      "seo_description": "Discover Richmond high-speed internet apartments at Pointe at River City. Enjoy seamless connectivity in a modern living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-richmond-va-community-860",
      "search_query": "two bedroom apartments richmond va",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Richmond, VA",
      "h2_subtitle": "Explore spacious two-bedroom apartments in Richmond, VA at Pointe at River City. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Find your perfect home at Pointe at River City, offering stylish two-bedroom apartments in Richmond, VA. Our spacious layouts feature modern designs with vaulted ceilings and upgraded kitchens, ensuring comfort and functionality. Each apartment is designed with your needs in mind, providing ample space for relaxation and entertainment.\n\nLocated in the charming Henrico County, residents enjoy a vibrant community complete with a refreshing swimming pool, hardwood flooring, and pet-friendly outdoor spaces. Our commitment to convenience is evident with amenities like 24-hour emergency maintenance and flexible rent payment options. Experience the warmth and luxury of Pointe at River City and discover what makes our community the ideal choice for apartment living in Richmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Richmond, VA",
      "seo_description": "Discover Richmond's two-bedroom apartments at Pointe at River City. Modern living with top amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-near-jacob-adams-elementary-richmond-571",
      "search_query": "apartments near Jacob L. Adams Elementary Richmond VA",
      "category": "School",
      "h1_title": "Apartments Near Jacob L. Adams Elementary",
      "h2_subtitle": "Pointe at River City offers convenient living near Jacob L. Adams Elementary in Richmond, VA. Enjoy the perks of our modern apartment community.",
      "page_copy": "Located just a short distance from Jacob L. Adams Elementary, Pointe at River City provides ideal apartment living in Richmond, VA. Our pet-friendly community offers two-bedroom layouts, perfect for families or roommates seeking proximity to quality education.\n\nOur apartments feature modern comforts including upgraded kitchens and hardwood flooring, set in a community with a refreshing pool and 24-hour maintenance. Enjoy vaulted ceilings and high-speed internet access, ensuring that both your lifestyle and tech needs are met. Pointe at River City combines convenience with a welcoming atmosphere, making it the perfect home near Jacob L. Adams Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jacob L. Adams Elementary School",
      "seo_description": "Find apartments near Jacob L. Adams Elementary in Richmond at Pointe at River City. Enjoy modern living close to local schools.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "housing-close-to-laburnum-elementary-henrico-483",
      "search_query": "housing close to Laburnum Elementary Henrico County",
      "category": "School",
      "h1_title": "Housing Near Laburnum Elementary",
      "h2_subtitle": "Pointe at River City offers convenient housing close to Laburnum Elementary in Henrico County. Discover your ideal home today.",
      "page_copy": "Discover the convenience of living at Pointe at River City, offering ideal housing close to Laburnum Elementary in Henrico County. Our community provides families with a perfect location, ensuring that quality education is just a short distance away.\n\nPointe at River City features spacious two-bedroom apartments with modern amenities such as hardwood flooring and upgraded kitchens. Enjoy community perks like a refreshing swimming pool and high-speed internet access. Our pet-friendly environment and 24-hour emergency maintenance ensure a comfortable and stress-free living experience. Choose Pointe at River City for a balanced lifestyle in Henrico County, just minutes from Laburnum Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Laburnum Elementary in Henrico",
      "seo_description": "Find housing near Laburnum Elementary at Pointe at River City. Enjoy modern living in Henrico County, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "rentals-by-linwood-holton-elementary-richmond-386",
      "search_query": "rentals by Linwood Holton Elementary School Richmond",
      "category": "School",
      "h1_title": "Rentals by Linwood Holton Elementary",
      "h2_subtitle": "Explore rentals near Linwood Holton Elementary School in Richmond, VA, at Pointe at River City. Find your perfect home today.",
      "page_copy": "Pointe at River City presents an excellent living option for those seeking rentals by Linwood Holton Elementary School in Richmond, VA. Our spacious two-bedroom apartments are designed with comfort and style in mind, providing a welcoming atmosphere for families and professionals alike.\n\nLocated in the vibrant Henrico County, our community features amenities such as upgraded kitchens, vaulted ceilings, and a sparkling swimming pool. We offer the convenience of high-speed internet and 24-hour emergency maintenance to cater to your lifestyle needs. Choose Pointe at River City for a comfortable home with easy access to Linwood Holton Elementary and all that Richmond has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Linwood Holton Elementary Richmond",
      "seo_description": "Discover rentals near Linwood Holton Elementary at Pointe at River City. Enjoy modern amenities and community features in Richmond, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "flats-near-martin-luther-king-jr-middle-richmond-402",
      "search_query": "flats near Martin Luther King Jr. Middle School Richmond VA",
      "category": "School",
      "h1_title": "Flats Near Martin Luther King Jr. Middle School",
      "h2_subtitle": "Pointe at River City offers comfortable flats near Martin Luther King Jr. Middle School in Richmond, VA. Discover modern living today.",
      "page_copy": "Welcome to Pointe at River City, where you can find comfortable flats near Martin Luther King Jr. Middle School in Richmond, VA. Our two-bedroom apartments offer spacious living with modern amenities, perfect for families and individuals looking to reside close to a quality education institution.\n\nOur community boasts upgraded kitchens, hardwood floors, and vaulted ceilings, creating a stylish and inviting atmosphere. Enjoy community amenities like our refreshing swimming pool and high-speed internet, ensuring convenience and relaxation at your doorstep. With 24-hour emergency maintenance and pet-friendly policies, Pointe at River City provides a seamless blend of comfort and accessibility near Martin Luther King Jr. Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flats Near Martin Luther King Jr. Middle Richmond",
      "seo_description": "Find modern flats near Martin Luther King Jr. Middle School at Pointe at River City. Enjoy stylish living in Richmond, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "housing-options-by-armstrong-high-school-richmond-191",
      "search_query": "housing options by Armstrong High School Richmond",
      "category": "School",
      "h1_title": "Housing Options by Armstrong High School",
      "h2_subtitle": "Discover exceptional housing options near Armstrong High School in Richmond, VA. Explore your next home at Pointe at River City.",
      "page_copy": "Pointe at River City offers a variety of superb housing options by Armstrong High School, located in the vibrant city of Richmond, VA. Our community provides spacious two-bedroom apartments, perfect for those who value proximity to excellent education and the heart of the city.\n\nExperience modern living with amenities such as upgraded kitchens, hardwood floors, and vaulted ceilings. Residents can enjoy the refreshing swimming pool, convenient flex rent payments, and access to high-speed internet. With pet-friendly policies and 24-hour emergency maintenance, Pointe at River City offers a stress-free, comfortable living environment for those seeking housing near Armstrong High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Options by Armstrong High School Richmond",
      "seo_description": "Explore housing options near Armstrong High School at Pointe at River City. Enjoy spacious, modern living in Richmond, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-close-to-reynolds-community-college-643",
      "search_query": "apartments close to Reynolds Community College Downtown Richmond",
      "category": "School",
      "h1_title": "Apartments Close to Reynolds Community College",
      "h2_subtitle": "Find perfect apartments close to Reynolds Community College Downtown Richmond, VA at Pointe at River City. Experience convenience and comfort.",
      "page_copy": "Located just a short distance from Reynolds Community College Downtown, Pointe at River City offers apartments that combine convenience with modern amenities. Ideal for students and professionals alike, our community provides a welcoming environment close to Richmond's bustling downtown and educational opportunities.\n\nOur pet-friendly apartments feature open layouts with upgraded kitchens, hardwood flooring, and vaulted ceilings. Take advantage of our high-speed internet and relax by our swimming pool after a day of studies or work. With 24-hour emergency maintenance and flexible rent payments, Pointe at River City is the smart choice for anyone seeking quality living near Reynolds Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Reynolds Community College",
      "seo_description": "Discover Pointe at River City apartments close to Reynolds Community College in Downtown Richmond, VA. Enjoy easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "housing-near-virginia-commonwealth-university-richmond-207",
      "search_query": "housing near Virginia Commonwealth University Richmond",
      "category": "School",
      "h1_title": "Housing Near Virginia Commonwealth University",
      "h2_subtitle": "Explore quality housing near Virginia Commonwealth University in Richmond, VA at Pointe at River City. Enjoy comfortable living close to campus.",
      "page_copy": "Discover Pointe at River City, offering ideal housing near Virginia Commonwealth University in vibrant Richmond, VA. Our spacious two-bedroom residences provide a serene escape just a short drive from VCU's dynamic campus life, making it perfect for students, faculty, and staff seeking proximity and peace.\n\nOur community is highlighted by upgraded kitchens, beautiful hardwood flooring, and spacious vaulted ceilings. Residents benefit from amenities like high-speed internet, emergency maintenance available 24-hours, and a refreshing swimming pool, all set within pet-friendly grounds. Pointe at River City combines convenience and comfort, offering a welcoming home environment near Virginia Commonwealth University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Virginia Commonwealth University",
      "seo_description": "Find comfortable housing near Virginia Commonwealth University at Pointe at River City in Richmond, VA. Enjoy spacious living just minutes from campus.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-close-to-virginia-union-university-richmond-72",
      "search_query": "apartments close to Virginia Union University Richmond",
      "category": "School",
      "h1_title": "Apartments Close to Virginia Union University",
      "h2_subtitle": "Discover apartments close to Virginia Union University in Richmond, VA. Pointe at River City offers modern living and convenience.",
      "page_copy": "Pointe at River City presents an excellent choice for those seeking apartments close to Virginia Union University in Richmond, VA. Enjoy easy access to campus while enjoying the tranquility and modern amenities our community offers. Perfect for students and faculty, our pet-friendly apartments combine convenience with a welcoming atmosphere.\n\nOur units feature upgraded kitchens, expansive vaulted ceilings, and elegant hardwood flooring. Residents can relax by the sparkling swimming pool or make use of high-speed internet for their studies. With 24-hour emergency maintenance and flexible payment options, Pointe at River City ensures a hassle-free living experience near Virginia Union University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Virginia Union University",
      "seo_description": "Explore Pointe at River City apartments close to Virginia Union University in Richmond, VA. Enjoy modern amenities and convenient campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-near-bon-secours-richmond-community-hospital-520",
      "search_query": "apartments near Bon Secours Richmond Community Hospital Henrico County",
      "category": "Hospital",
      "h1_title": "Apartments Near Bon Secours Richmond Hospital",
      "h2_subtitle": "Find comfortable apartments near Bon Secours Richmond Community Hospital in Henrico County at Pointe at River City for modern and convenient living.",
      "page_copy": "Pointe at River City is the ideal community for those seeking apartments near Bon Secours Richmond Community Hospital in Henrico County. Our location offers unparalleled convenience for healthcare professionals and staff, providing a comfortable home close to where you work.\n\nOur two-bedroom apartments feature upgraded kitchens, vaulted ceilings, and hardwood flooring. Residents enjoy a range of amenities, including high-speed internet and a relaxing swimming pool. With 24-hour emergency maintenance and flexible rent options, Pointe at River City delivers a stress-free living experience near Bon Secours Richmond Community Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bon Secours Richmond Hospital",
      "seo_description": "Discover Pointe at River City apartments near Bon Secours Richmond Hospital in Henrico County. Modern living with convenience and amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-near-chimborazo-park-richmond-620",
      "search_query": "apartments near Chimborazo Park Richmond",
      "category": "Park",
      "h1_title": "Apartments Near Chimborazo Park",
      "h2_subtitle": "Explore stylish apartments near Chimborazo Park in Richmond, VA. Pointe at River City offers a vibrant living experience close to nature.",
      "page_copy": "Pointe at River City is your gateway to apartments near Chimborazo Park in Richmond, VA. Immerse yourself in the lush surroundings and enjoy easy access to one of the city's beautiful outdoor spaces while savoring the amenities our community offers.\n\nResidents of Pointe at River City benefit from upgraded kitchens, spacious vaulted ceilings, and serene hardwood flooring. The community is pet-friendly, making it ideal for park enthusiasts and their furry companions. With amenities such as a swimming pool, high-speed internet, and 24-hour emergency maintenance, residents are ensured a comfortable lifestyle near Chimborazo Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chimborazo Park Richmond",
      "seo_description": "Discover Pointe at River City, offering apartments near Chimborazo Park in Richmond, VA. Enjoy nature and stylish living in one ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-near-church-hill-dog-park-177",
      "search_query": "pet-friendly apartments near Church Hill Dog Park VA",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments Near Church Hill Park",
      "h2_subtitle": "Explore pet-friendly apartments near Church Hill Dog Park, VA. Pointe at River City offers a welcoming community for you and your pet.",
      "page_copy": "Looking for pet-friendly apartments near Church Hill Dog Park in VA? Pointe at River City offers a welcoming environment that's perfect for you and your furry friend. Enjoy the convenience of living close to a dog-friendly locale while experiencing the numerous amenities our community provides.\n\nWith spacious two-bedroom layouts, vaulted ceilings, and a range of outdoor areas, you'll find Pointe at River City is the ideal place for both you and your pet. Our community is equipped with upgraded kitchens, a swimming pool, and high-speed internet. Plus, our 24-hour emergency maintenance service and flexible payment options make for an easy living experience near Church Hill Dog Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Church Hill Park",
      "seo_description": "Find pet-friendly apartments near Church Hill Dog Park at Pointe at River City. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "spacious-rentals-close-to-libby-hill-park-410",
      "search_query": "spacious rentals close to Libby Hill Park Richmond",
      "category": "Park",
      "h1_title": "Spacious Rentals Close to Libby Hill Park",
      "h2_subtitle": "Discover spacious rentals close to Libby Hill Park in Richmond, VA. Pointe at River City offers modern living with stunning views.",
      "page_copy": "Located just a short distance from Libby Hill Park, Pointe at River City offers spacious rentals in Richmond, VA. Enjoy the lush landscapes and historic charm of this popular park while living in a community that prioritizes comfort and style.\n\nOur pet-friendly apartments feature two-bedroom layouts with vaulted ceilings and hardwood flooring, perfect for those seeking a blend of elegance and practicality. Amenities such as upgraded kitchens, a swimming pool, and 24-hour emergency maintenance ensure a relaxing lifestyle. Pointe at River City combines the tranquility of nature with the convenience of modern living near Libby Hill Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Rentals Close to Libby Hill Park",
      "seo_description": "Discover Pointe at River City, offering spacious rentals near Libby Hill Park in Richmond. Enjoy modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "modern-apartments-by-great-shiplock-park-612",
      "search_query": "modern apartments by Great Shiplock Park Henrico County",
      "category": "Park",
      "h1_title": "Modern Apartments by Great Shiplock Park",
      "h2_subtitle": "Find modern apartments by Great Shiplock Park in Henrico County. Experience luxury living at Pointe at River City.",
      "page_copy": "Pointe at River City presents modern apartments by Great Shiplock Park in Henrico County, perfect for those seeking a blend of urban convenience and natural beauty. Our stylish, pet-friendly community offers two-bedroom layouts with features like vaulted ceilings and hardwood flooring.\n\nLocated close to the scenic Great Shiplock Park, residents enjoy easy access to outdoor activities while benefiting from amenities such as upgraded kitchens, a refreshing swimming pool, and high-speed internet. Experience seamless living with our 24-hour emergency maintenance and flexible payment plans. Choose Pointe at River City for modern living near Great Shiplock Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments by Great Shiplock Park",
      "seo_description": "Explore Pointe at River City, featuring modern apartments by Great Shiplock Park in Henrico County. Enjoy luxury living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-park-richmond-521",
      "search_query": "apartments near Jefferson Park in Richmond",
      "category": "Park",
      "h1_title": "Apartments Near Jefferson Park, Richmond",
      "h2_subtitle": "Discover the perfect apartments near Jefferson Park in Richmond. Pointe at River City offers stylish living in a vibrant community.",
      "page_copy": "Looking for apartments near Jefferson Park in Richmond? Pointe at River City provides a prime location with easy access to this beautiful green space. Enjoy the natural beauty and recreational opportunities that Jefferson Park offers while living in a community designed with your convenience and comfort in mind.\n\nOur pet-friendly, modern apartments feature spacious two-bedroom layouts, vaulted ceilings, and hardwood flooring. With amenities like upgraded kitchens, a refreshing pool, and high-speed internet access, you'll find everything you need for a balanced lifestyle. Walkable to Jefferson Park and equipped with 24-hour emergency maintenance, Pointe at River City is your ideal urban retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Park, Richmond",
      "seo_description": "Explore Pointe at River City, offering apartments near Jefferson Park in Richmond. Enjoy modern amenities and convenient access to the park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166340",
      "source": "custom",
      "page_item_url": "outdoor-living-near-byrd-park-va-673",
      "search_query": "outdoor living near Byrd Park VA",
      "category": "Park",
      "h1_title": "Outdoor Living Near Byrd Park, VA",
      "h2_subtitle": "Experience vibrant outdoor living near Byrd Park, VA. Pointe at River City offers ideal accommodations for nature lovers.",
      "page_copy": "Embrace outdoor living near Byrd Park, VA, at Pointe at River City. Our community offers a seamless blend of modern comfort and access to one of Richmond's best-loved parks, perfect for those who love being close to nature.\n\nEnjoy spacious two-bedroom layouts with vaulted ceilings and hardwood flooring, providing the perfect setting for a tranquil sanctuary. With amenities such as a refreshing swimming pool and inviting outdoor spaces, our apartments are tailored for those who value both relaxation and recreation. Discover why Pointe at River City is the preferred choice for outdoor enthusiasts wanting easy access to Byrd Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a red front door and white columns.",
        "public_id": "01a015db-3b96-712d-ab6b-63868a1eef2f",
        "storage_key": "property/6767906449166340/01a015db-3b96-712d-ab6b-63868a1eef2f.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Outdoor Living Near Byrd Park, VA",
      "seo_description": "Discover Pointe at River City, where outdoor living near Byrd Park, VA, meets modern comfort. Enjoy spacious apartments and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5077"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976278155"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973426"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WBT5QQGJ"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://pointeatrivercity.fatwin.com/api/websites/resources/1?x=YkIrL2lxSUtrd2dqb044Vmk0cFNlU1VCa2dnQnZpQTJLUEcwbmpWa051T2ZibWJVVkFJN3ZSUS9nalIxK00wZ1lHaFl0eFZkaDRreC93R1JwTmNiTkE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvg8myypln"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95492cac-43e6-11ef-85ff-3fe60e45c474"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95492cac-43e6-11ef-85ff-3fe60e45c474/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95492cac-43e6-11ef-85ff-3fe60e45c474/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImZaOFZ6YWhTaXJJVngwTHBMdHdtVHc9PSIsInZhbHVlIjoiUTVBYzdDMzJRb0xnTFdoMmR0SG1lUT09IiwibWFjIjoiYzBlOTQ2YjNiYWFlMzY4Y2U4OWQ1ZGFjYjZiMmIyZmIxMWUwMzc4MTEwZDk0MDc1OTM3ZTMwYWNkZDVmMThlMSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5077",
  "custom_repli_id": "9976278155",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4973426",
  "custom_google_gtm_id": "GTM-WBT5QQGJ",
  "custom_perq_script_url": "https://pointeatrivercity.fatwin.com/api/websites/resources/1?x=YkIrL2lxSUtrd2dqb044Vmk0cFNlU1VCa2dnQnZpQTJLUEcwbmpWa051T2ZibWJVVkFJN3ZSUS9nalIxK00wZ1lHaFl0eFZkaDRreC93R1JwTmNiTkE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/yzvg8myypln",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95492cac-43e6-11ef-85ff-3fe60e45c474",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95492cac-43e6-11ef-85ff-3fe60e45c474/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95492cac-43e6-11ef-85ff-3fe60e45c474/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImZaOFZ6YWhTaXJJVngwTHBMdHdtVHc9PSIsInZhbHVlIjoiUTVBYzdDMzJRb0xnTFdoMmR0SG1lUT09IiwibWFjIjoiYzBlOTQ2YjNiYWFlMzY4Y2U4OWQ1ZGFjYjZiMmIyZmIxMWUwMzc4MTEwZDk0MDc1OTM3ZTMwYWNkZDVmMThlMSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "db9b6097-a50c-4af9-8b62-8114b821e6d6",
  "custom_audioeye_site_hash": "4059de0d52a692d330b85388b15defb2"
};

export const generatedAt = '2026-10-22T20:06:03.557Z';
